<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/agcs" back-text="Assembleias">
            <ai-analysis-button
                v-if="!page.isNew && dataset.data.id"
                :endpoint="`/api/admin/ai/general-meetings/${dataset.data.id}/check`"
                label="Verificar com IA"
                title="Checklist IA da AGC"
            />
            <v-btn v-if="(page.isNew) && $allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.addLoading" @click="add">Salvar</v-btn>
            <v-btn v-else-if="$allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.updateLoading" @click="update">Salvar</v-btn>
        </ui-page-header>

        <div v-if="dataset.loading && !page.isNew" class="text-center py-10">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <div class="mt-4 ui-muted">Carregando dados da assembleia...</div>
        </div>

        <v-form ref="form" v-model="dataForm.validForm" v-if="page.isNew || (!dataset.loading && dataset.data.id)" class="agc-details-sections">
                    <ui-section title="Detalhes da Assembleia">
                        <template v-if="!page.isNew && dataset.data.status !== null" #actions>
                            <div class="status-actions d-flex align-center">
                                <ui-badge v-if="dataset.data.status === 3" text="Suspensa" tone="warning" class="mr-3" />
                                <ui-badge v-if="dataset.data.status === 2" text="Interrompida" tone="danger" class="mr-3" />
                                <ui-badge v-if="dataset.data.status === 0" text="Aberta" tone="primary" class="mr-3" />
                                <ui-badge v-if="dataset.data.status === 5" text="Em andamento" tone="success" class="mr-3" />
                                <ui-badge v-if="dataset.data.status === 1" text="Fechada" tone="primary" class="mr-3" />
                                <ui-badge v-if="dataset.data.status === 4" text="Finalizada" tone="neutral" class="mr-3" />

                                <div class="icon-container py-1 px-2 ml-2">
                                    
                                    <v-tooltip bottom v-if="dataset.data.status === 1">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 1, 0)" size="large" color="primary" class="mx-1">
                                                mdi-reload
                                            </v-icon>
                                        </template>
                                        <span>Abrir Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 4 || dataset.data.status === 5 || dataset.data.status === 2 || dataset.data.status === 0">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 10, 0)" size="large" color="primary" class="mx-1">
                                                mdi-reload
                                            </v-icon>
                                        </template>
                                        <span>Reabrir Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 3">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 11, 5)" size="large" color="success" class="mx-1">
                                                mdi-play-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>Prosseguir Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 0 || dataset.data.status === 1">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 8, 5)" size="large" color="success" class="mx-1">
                                                mdi-play-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>Iniciar Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 5 || dataset.data.status === 0 || dataset.data.status === 1">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 3, 3)" size="large" color="warning" class="mx-1">
                                                mdi-pause-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>Suspender Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="!(dataset.data.status === 4 || dataset.data.status === 2)">
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" @click="openInterruptionDialog(dataset.data.id, 7, 2)" size="large" color="error" class="mx-1">
                                                mdi-close-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>Interromper Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 5">
                                        <template #activator="{ on }">
                                            <v-icon v-if="$allowed('gm.conduct')" v-on="on" @click="actionGeneralMeeting(dataset.data.id, 9, 4)" size="large" color="teal" class="mx-1">
                                                mdi-check-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>Finalizar Assembleia</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 0 || dataset.data.status === 1">
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" @click="openDialogInsertNotice(dataset.data)" size="large" color="info" class="mx-1">
                                                mdi-file-document-plus-outline
                                            </v-icon>
                                        </template>
                                        <span>Adicionar Edital</span>
                                    </v-tooltip>

                                    <v-tooltip bottom v-if="dataset.data.status === 0 || dataset.data.status === 1">
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" @click="openAddInformationModal(dataset.data)" size="large" color="secondary" class="mx-1">
                                                mdi-file-document-edit-outline
                                            </v-icon>
                                        </template>
                                        <span>Adicionar Informações</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </template>
                            <v-row>
                                <v-col cols="12" md="5">
                                    <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <!-- Tipo da assembleia: define a regra do quorum de instalacao -->
                                <!-- Prosseguimento e sub-opcao da 1a/2a convocacao: nasce da suspensao e nao troca de tipo -->
                                <v-col cols="12" md="4">
                                    <v-text-field v-if="isContinuationMeeting" dense label="Tipo de assembleia" :value="continuationTypeLabel"
                                        readonly outlined hide-details="auto" :hint="convocationRule" persistent-hint>
                                    </v-text-field>
                                    <v-select v-else dense label="Tipo de assembleia" v-model="dataset.data.convocation_type"
                                        :items="convocationOptions" item-value="id" item-text="name" required
                                        :rules="[$rules.required]" outlined hide-details="auto"
                                        :hint="convocationRule" persistent-hint>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field dense type="datetime-local" label="Data (horário de Brasília - BRT)" v-model="computedDateInput" required
                                        :rules="[$rules.required]" outlined hide-details="auto" @input="updateDate">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="dataset.data.next_convocation_date">
                                    <v-text-field dense label="Próxima convocação"
                                        :value="formatDateTime(dataset.data.next_convocation_date)" readonly outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-alert v-if="isContinuationMeeting" type="info" text dense class="mb-0">
                                        Prosseguimento usa a mesma cotação registrada na sessão de instalação. Estes campos não podem ser alterados.
                                    </v-alert>
                                    <v-alert v-else type="info" text dense class="mb-0">
                                        Informe as cotações usadas para converter créditos em moeda estrangeira na AGC.
                                        Após iniciar a assembleia, estes campos ficam bloqueados.
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined hide-details="auto" label="Cotação USD"
                                        type="number" step="0.000001" min="0"
                                        v-model="dataset.data.exchange_rate_usd"
                                        :disabled="exchangeRatesLocked">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined hide-details="auto" label="Cotação EUR"
                                        type="number" step="0.000001" min="0"
                                        v-model="dataset.data.exchange_rate_eur"
                                        :disabled="exchangeRatesLocked">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined hide-details="auto" label="Data-base da cotação (BRT)"
                                        type="datetime-local"
                                        v-model="computedExchangeRateDateInput"
                                        :disabled="exchangeRatesLocked"
                                        @input="updateExchangeRateDate">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete dense id="type" :items="dataset.clients" label="Caso"
                                        v-model="dataset.data.client_id" item-value="id" item-text="name" outlined
                                        hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <!-- Prosseguimento nasce da suspensao da sessao instalada, nao de "+ Incluir" -->
                            <v-alert v-if="page.isNew && continuationWarning" type="warning" text dense class="mt-4 mb-0">
                                <template v-if="installedSessions.length">
                                    Este caso já tem sessão instalada ({{ installedSessions.map((item) => item.text).join("; ") }}).
                                </template>
                                Se esta AGC for a <strong>continuação</strong> de uma sessão instalada, não crie aqui: abra a sessão que instalou e use
                                <strong>Suspender Assembleia</strong>, que cria o prosseguimento ligado à instalação e ao histórico.
                                Criada por aqui, ela conta como sessão nova (quórum do zero).
                            </v-alert>
                            <v-alert v-if="canConvertToContinuation" type="warning" text dense class="mt-4 mb-0">
                                <div class="d-flex align-center flex-wrap" style="gap: 12px;">
                                    <span class="flex-grow-1">
                                        Esta AGC foi criada como <strong>sessão nova</strong>. Se ela é a continuação de uma sessão instalada
                                        ({{ installedSessions.map((item) => item.text).join("; ") }}), transforme em prosseguimento para herdar a instalação e o histórico.
                                    </span>
                                    <v-btn v-if="$allowed('gm.conduct')" small outlined color="warning" @click="openConvert">
                                        <v-icon left small>mdi-link-variant</v-icon>Transformar em prosseguimento
                                    </v-btn>
                                </div>
                            </v-alert>
                            <v-divider class="my-5"></v-divider>
                            <v-row align="center">
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="dataset.data.accreditation_enabled"
                                        label="Permitir credenciamento pelo site"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="datetime-local" label="Abertura do credenciamento (BRT)"
                                        v-model="computedAccreditationStartsAt" hide-details="auto"
                                        :disabled="!dataset.data.accreditation_enabled">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined type="datetime-local" label="Encerramento do credenciamento (BRT)"
                                        v-model="computedAccreditationEndsAt" hide-details="auto"
                                        :disabled="!dataset.data.accreditation_enabled">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="!page.isNew">
                                    <v-alert :type="accreditationAvailabilityType" text dense class="mb-0">
                                        <div class="d-flex align-center justify-space-between">
                                            <span>{{ accreditationAvailabilityMessage }}</span>
                                            <v-btn v-if="(dataset.data.accreditation_availability && dataset.data.accreditation_availability.is_open) && $allowed('gm.accreditation_window')"
                                                small outlined color="warning" @click="changeAccreditationAvailability('close')">
                                                Encerrar agora
                                            </v-btn>
                                            <v-btn v-else-if="(dataset.data.accreditation_closed_at) && $allowed('gm.accreditation_window')"
                                                small outlined color="success" @click="changeAccreditationAvailability('reopen')">
                                                Reabrir credenciamento
                                            </v-btn>
                                        </div>
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <p class="font-weight-bold mb-1">Descrição</p>
                                    <tiptap-vuetify v-model="dataset.data.description" :rules="[$rules.required]"
                                        :extensions="extensions" hide-details="auto" />
                                </v-col>
                            </v-row>
                    </ui-section>

                    <ui-section v-if="!page.isNew" title="Zoom da AGC">
                        <template #actions>
                            <v-btn v-if="$allowed('save')" small outlined color="primary" :loading="zoom.loading" @click="saveZoom(false)">
                                Salvar configuração
                            </v-btn>
                            <v-btn small color="primary" depressed :loading="zoom.loading" @click="saveZoom(true)">
                                Gerar/atualizar reunião
                            </v-btn>
                            <v-btn small outlined color="primary" :loading="zoom.syncLoading" :disabled="!dataset.data.zoom_enabled" @click="syncZoomRegistrants">
                                Sincronizar links
                            </v-btn>
                        </template>
                            <v-alert type="info" text dense>
                                O Meeting ID, host e link geral são gerados automaticamente pela integração Zoom. Os links individuais são gerados por credor autorizado e toda tentativa de acesso fica registrada nas movimentações do credor com esta AGC.
                            </v-alert>
                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-switch dense inset label="Habilitar Zoom" v-model="dataset.data.zoom_enabled" hide-details="auto"></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-switch dense inset label="Criar automaticamente" v-model="dataset.data.zoom_auto_create" hide-details="auto"></v-switch>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense outlined label="Tipo" :items="zoom.types" item-text="name" item-value="id"
                                        v-model="dataset.data.zoom_type" hide-details="auto"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field dense outlined type="number" min="1" label="Duração (min)"
                                        v-model="dataset.data.zoom_duration" hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Zoom Meeting ID"
                                        :value="dataset.data.zoom_meeting_id || 'Gerado automaticamente'" readonly hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined label="Status Zoom"
                                        :value="dataset.data.zoom_status || 'Não sincronizado'" readonly hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="8">
                                    <v-text-field dense outlined label="Link geral Zoom"
                                        :value="dataset.data.zoom_join_url || 'Gerado automaticamente'" readonly hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field dense outlined label="Última sincronização"
                                        :value="dataset.data.zoom_last_synced_at ? $options.filters.defaultDate(dataset.data.zoom_last_synced_at, 'DD/MM/YYYY HH:mm [BRT]') : 'N/A'"
                                        readonly hide-details="auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-alert v-if="zoom.lastSyncMessage" type="success" text dense class="mb-0">
                                {{ zoom.lastSyncMessage }}
                            </v-alert>
                    </ui-section>

                    <ui-section v-if="!page.isNew" title="Editais">
                        <template #actions>
                            <v-btn v-if="$allowed('create')"
                                color="primary"
                                depressed
                                small
                                @click="openDialogInsertNotice(dataset.data)"
                            >
                                <v-icon left small>mdi-plus</v-icon> Adicionar Edital
                            </v-btn>
                        </template>
                            <v-alert v-if="!dataset.data.notices || dataset.data.notices.length === 0" type="info" text dense class="mb-0">
                                Nenhum edital cadastrado.
                            </v-alert>
                            <v-simple-table v-else>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Nome</th>
                                            <th class="text-left">Data de envio</th>
                                            <th class="text-right" style="width: 56px;"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="notice in dataset.data.notices" :key="notice.id">
                                            <td class="ui-cell-main">{{ notice.name }}</td>
                                            <td>{{ notice.created_at | defaultDate("DD/MM/YYYY HH:mm [BRT]") }}</td>
                                            <td class="text-right">
                                                <ui-row-actions :actions="[
                                                    { text: 'Visualizar', icon: 'mdi-eye-outline', handler: () => viewNoticeFile(notice) },
                                                    { text: 'Excluir', icon: 'mdi-delete-outline', handler: () => deleteNotice(notice), danger: true , disabled: !$allowed('delete') },
                                                ]" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                    </ui-section>

	                    <ui-section v-if="!page.isNew" title="Votação">
	                        <template #actions>
	                            <v-btn
	                                color="primary"
	                                outlined
	                                small
	                                @click="goToScenarios()"
	                            >
	                                <v-icon left small>mdi-account-cancel-outline</v-icon> Cenários
	                            </v-btn>
	                            <v-btn v-if="$allowed('create')"
	                                color="primary"
	                                depressed
	                                small
	                                @click="openVotingForm(true)"
	                            >
	                                <v-icon left small>mdi-plus</v-icon> Incluir Votação
	                            </v-btn>
	                        </template>
	                            <v-form :readonly="!$allowed('save')" v-if="voting.form.show" ref="votingForm" v-model="voting.form.valid" class="mb-4">
	                                <v-row>
	                                    <v-col cols="12" md="6">
	                                        <v-text-field dense label="Nome da votação" v-model="voting.form.data.name"
	                                            :rules="[$rules.required]" outlined hide-details="auto">
	                                        </v-text-field>
	                                    </v-col>
	                                    <v-col cols="12" md="6">
	                                        <v-text-field dense label="Descrição da votação" v-model="voting.form.data.description"
	                                            :rules="[$rules.required]" outlined hide-details="auto">
	                                        </v-text-field>
	                                    </v-col>
	                                </v-row>
	                                <v-row>
	                                    <v-col cols="12" md="6">
	                                        <v-select dense :items="voting.types" label="Tipo"
	                                            v-model="voting.form.data.type" item-value="id" item-text="name"
	                                            :rules="[$rules.required]" outlined hide-details="auto">
	                                        </v-select>
	                                    </v-col>
	                                    <v-col cols="12" md="6">
	                                        <v-select dense :items="voting.statuses" label="Status"
	                                            v-model="voting.form.data.status" item-value="id" item-text="name"
	                                            :rules="[$rules.required]" outlined hide-details="auto">
	                                        </v-select>
	                                    </v-col>
	                                </v-row>
	                                <!-- Cenarios da assembleia marcados nesta votacao: os mesmos votos sao apurados em cada um. -->
	                                <v-row>
	                                    <v-col cols="12">
	                                        <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 8px;">
	                                            <span class="font-weight-medium">Cenários desta votação</span>
	                                            <v-btn text small color="primary" @click.stop="openScenarioDialog()">
	                                                <v-icon left small>mdi-cog-outline</v-icon>
	                                                Gerenciar cenários
	                                            </v-btn>
	                                        </div>
	                                        <div v-if="!scenario.items.length" class="ui-small ui-muted">
	                                            Esta assembleia ainda não tem cenários. Sem cenário, a votação é apurada pelo QGC do caso.
	                                        </div>
	                                        <div v-else class="d-flex flex-wrap" style="gap: 0 24px;">
	                                            <v-checkbox v-for="item in scenario.items" :key="item.id" v-model="voting.form.data.scenario_ids"
	                                                :value="item.id" :label="item.name" dense hide-details class="mt-1" />
	                                        </div>
	                                        <div class="ui-small ui-muted mt-2">
	                                            O cenário é da assembleia e pode ser marcado em várias votações. Os votos são registrados uma vez e refletidos em cada cenário marcado.
	                                        </div>
	                                    </v-col>
	                                    <v-col cols="12">
	                                        <v-select dense :items="baseScenarioOptions" label="Quem pode votar (cenário base)"
	                                            v-model="voting.form.data.scenario_id" item-value="id" item-text="name"
	                                            outlined hide-details="auto" :menu-props="{ offsetY: true }"
	                                            hint="O cenário base define quem vota e o resultado oficial desta votação." persistent-hint>
	                                        </v-select>
	                                    </v-col>
	                                </v-row>
	                                <v-row>
	                                    <v-col cols="12" class="d-flex justify-end">
	                                        <v-btn color="grey" text @click="closeVotingForm" :disabled="voting.form.loading">
	                                            Cancelar
	                                        </v-btn>
	                                        <v-btn v-if="$allowed('save')" color="primary" elevation="0" class="ml-2" @click="saveVotingForm" :loading="voting.form.loading">
	                                            Salvar
	                                        </v-btn>
	                                    </v-col>
	                                </v-row>
	                                <v-divider class="my-4"></v-divider>
	                            </v-form>

	                            <v-alert v-if="!voting.loading && voting.items.length === 0" type="info" text dense class="mb-0">
	                                Esta assembleia ainda não possui uma votação cadastrada.
	                            </v-alert>
	                            <v-data-table v-else
	                                :headers="voting.headers"
	                                :items="voting.items"
	                                :loading="voting.loading"
	                                :disable-sort="true"
	                                :disable-pagination="true"
	                                hide-default-footer
	                                no-data-text="Nenhuma votação encontrada"
	                                loading-text="Carregando votações...">
	                                <template v-slot:[`item.name`]="{ item }">
	                                    <span class="ui-cell-main">{{ item.name }}</span>
	                                </template>
	                                <template v-slot:[`item.type`]="{ item }">
	                                    <ui-badge :text="getVotingTypeName(item.type)" tone="primary" :dot="false" />
	                                </template>
	                                <template v-slot:[`item.scenario`]="{ item }">
	                                    <span v-if="!(item.scenarios || []).length && !item.scenario" class="ui-muted">Sem cenário</span>
	                                    <div v-else>
	                                        <div class="ui-cell-main">{{ (item.scenarios || []).length || 1 }} cenário(s)</div>
	                                        <div class="ui-cell-sub">{{ item.scenario ? `Base: ${item.scenario.name}` : 'Base: QGC do caso' }}</div>
	                                    </div>
	                                </template>
	                                <template v-slot:[`item.status`]="{ item }">
	                                    <ui-badge :text="getVotingStatusName(item.status)" :color="getVotingStatusColor(item.status)" />
	                                </template>
	                                <template v-slot:[`item.created_at`]="{ item }">
	                                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm [BRT]") }}
	                                </template>
	                                <template v-slot:[`item.actions`]="{ item }">
	                                    <ui-row-actions :actions="[
	                                        { text: 'Votação', icon: 'mdi-vote-outline', handler: () => goToVoting(item) },
	                                        { text: 'Editar votação', icon: 'mdi-pencil-outline', handler: () => openVotingForm(false, item) , disabled: !$allowed('edit') },
	                                        { text: 'Iniciar votação', icon: 'mdi-play-circle-outline', handler: () => setVotingStatus(item, 2) },
	                                        { text: 'Pausar votação', icon: 'mdi-pause-circle-outline', handler: () => setVotingStatus(item, 3) },
	                                        { text: 'Finalizar votação', icon: 'mdi-stop-circle-outline', handler: () => setVotingStatus(item, 4) },
	                                        { text: 'Publicar resultado', icon: 'mdi-check-decagram-outline', handler: () => setVotingStatus(item, 5), hidden: item.status !== 4 },
	                                        { text: 'Excluir votação', icon: 'mdi-delete-outline', handler: () => deleteVoting(item), danger: true , disabled: !$allowed('delete') },
	                                    ]" />
	                                </template>
	                            </v-data-table>
	                    </ui-section>

            <v-dialog
                v-model="scenario.dialog"
                max-width="1540px"
                width="calc(100vw - 48px)"
                content-class="scenario-dialog"
                persistent
            >
                <v-card class="scenario-dialog-card">
                    <v-card-title class="modal-title d-flex justify-space-between align-center">
                        <span>Cenários de votação</span>
                        <v-btn icon @click="closeScenarioDialog" :disabled="scenario.loading || scenario.form.loading">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="scenario-dialog-body">
                        <div class="scenario-toolbar">
                            <div class="scenario-selector-field">
                                <v-autocomplete
                                    dense
                                    outlined
                                    clearable
                                    label="Cenário cadastrado"
                                    :items="scenario.items"
                                    item-text="name"
                                    item-value="id"
                                    :value="scenario.form.data.id"
                                    hide-details="auto"
                                    no-data-text="Nenhum cenário cadastrado"
                                    @change="selectScenarioById"
                                ></v-autocomplete>
                            </div>
                            <div class="scenario-name-field">
                                <v-text-field dense label="Nome do cenário" v-model="scenario.form.data.name"
                                    outlined hide-details="auto">
                                </v-text-field>
                            </div>
                            <div class="scenario-actions">
                                <v-btn v-if="$allowed('create')" color="primary" outlined elevation="0" @click="newScenario" :disabled="scenario.form.loading">
                                    Novo
                                </v-btn>
                                <v-btn
                                    v-if="(scenario.form.data.id) && $allowed('delete')"
                                    color="error"
                                    outlined
                                    elevation="0"
                                    @click="deleteScenario(scenario.form.data)"
                                    :disabled="scenario.form.loading">
                                    Excluir
                                </v-btn>
                                <v-btn v-if="$allowed('save')" color="primary" elevation="0" @click="saveScenario" :loading="scenario.form.loading">
                                    Salvar cenário
                                </v-btn>
                            </div>
                        </div>

                        <div class="scenario-management-layout">
                            <section class="scenario-workspace">
                                <div class="scenario-section-label mb-2">Credores habilitados para voto</div>
                                <v-alert type="info" text dense class="mb-3">
                                    Marque na coluna <strong>Sem voto</strong> os credores que não poderão participar deste cenário.
                                </v-alert>
                                <v-row dense class="mb-3">
                                    <v-col cols="12" md="8">
                                        <v-text-field dense label="Pesquisar credor" v-model="scenario.filter"
                                            outlined hide-details="auto">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" class="d-flex justify-end">
                                        <v-btn color="primary" outlined elevation="0" @click="addManualScenarioParticipant">
                                            <v-icon left small>mdi-account-plus-outline</v-icon>
                                            Credor manual
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-data-table
                                    :headers="scenario.headers"
                                    :items="filteredScenarioCreditors"
                                    :loading="scenario.loading"
                                    :disable-sort="true"
                                    :items-per-page="15"
                                    fixed-header
                                    height="520"
                                    class="app-table hover-table scenario-creditors-table"
                                    no-data-text="Nenhum credor aprovado para voto encontrado"
                                    loading-text="Carregando credores..."
                                    :footer-props="{ itemsPerPageText: 'Itens por pág:', itemsPerPageOptions: [10, 15, 25, 50] }"
                                >
                                    <template v-slot:[`item.blocked`]="{ item }">
                                        <v-checkbox
                                            dense
                                            hide-details
                                            class="ma-0 pa-0"
                                            :input-value="isScenarioCreditorBlocked(item)"
                                            @change="toggleScenarioBlockedCreditor(item)"
                                        ></v-checkbox>
                                    </template>
	                                    <template v-slot:[`item.amount`]="{ item }">
	                                        <v-currency-field dense hide-details outlined v-model="item.amount"
                                                :allow-negative="false" style="max-width: 140px;"></v-currency-field>
	                                    </template>
	                                    <template v-slot:[`item.scenario_class`]="{ item }">
	                                        <v-select dense hide-details outlined :items="dataset.creditorTypes"
                                                v-model="item.scenario_class" item-value="id" item-text="name"
                                                style="max-width: 180px;"></v-select>
	                                    </template>
	                                    <template v-slot:[`item.currency`]="{ item }">
	                                        <v-select dense hide-details outlined :items="dataset.currencyTypes"
                                                v-model="item.currency" item-value="id" item-text="currencyFormat"
                                                style="max-width: 100px;"></v-select>
	                                    </template>
	                                    <template v-slot:[`item.name`]="{ item }">
	                                        <v-text-field v-if="Number(item.origin) === 2" dense hide-details outlined v-model="item.name"></v-text-field>
	                                        <span v-else>{{ item.name }}</span>
	                                    </template>
	                                    <template v-slot:[`item.registration`]="{ item }">
	                                        <v-text-field v-if="Number(item.origin) === 2" dense hide-details outlined
                                                v-model="item.registration"
                                                v-mask="(item.registration || '').replace(/\D/g, '').length <= 11 ? $masks.cpf : $masks.cnpj"
                                                @blur="item.registration = formatRegistrationValue(item.registration)">
                                            </v-text-field>
	                                        <span v-else>{{ formatRegistrationValue(item.registration) }}</span>
	                                    </template>
	                                    <template v-slot:[`item.has_presence`]="{ item }">
	                                        <v-chip small label :color="item.has_presence ? 'success' : 'grey'" text-color="white">
	                                            {{ item.has_presence ? 'Sim' : 'Não' }}
	                                        </v-chip>
	                                    </template>
	                                    <template v-slot:[`item.actions`]="{ item }">
	                                        <v-btn icon small v-if="Number(item.origin) === 2" @click="removeManualScenarioParticipant(item)">
	                                            <v-icon color="error" small>mdi-delete-outline</v-icon>
	                                        </v-btn>
	                                    </template>
                                </v-data-table>
                            </section>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="interruptionDialog.show" max-width="560px" persistent>
                <v-card>
                    <v-card-title class="modal-title d-flex justify-space-between align-center">
                        <span>{{ interruptionDialog.type === 3 ? 'Suspender Assembleia' : 'Interromper Assembleia' }}</span>
                        <v-btn icon @click="closeInterruptionDialog" :disabled="interruptionDialog.loading">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-alert type="warning" text dense class="mb-4">
                            {{ interruptionDialog.type === 3
                                ? 'A suspensão criará uma nova assembleia vinculada e preservará esta sessão para auditoria.'
                                : 'Informe a próxima data da assembleia, caso já exista uma data definida.' }}
                        </v-alert>
                        <v-text-field
                            dense
                            outlined
                            type="datetime-local"
                            label="Próxima data (BRT)"
                            v-model="interruptionDialog.nextConvocationDate"
                            hide-details="auto"
                        ></v-text-field>
                        <v-textarea
                            v-if="interruptionDialog.type === 3"
                            dense outlined rows="3" class="mt-4"
                            label="Motivo da suspensão"
                            v-model="interruptionDialog.reason"
                            hide-details="auto"
                        ></v-textarea>
                        <v-radio-group
                            v-if="interruptionDialog.type === 3"
                            v-model="interruptionDialog.votingReuseMode"
                            class="mt-4" hide-details="auto"
                        >
                            <template #label><strong>Votações da sessão suspensa</strong></template>
                            <v-radio label="Não reaproveitar votações" value="none"></v-radio>
                            <v-radio label="Copiar estrutura, sem os votos (recomendado)" value="structure"></v-radio>
                            <v-radio label="Copiar estrutura e votos já registrados" value="structure_and_votes"></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="closeInterruptionDialog" :disabled="interruptionDialog.loading">
                            Cancelar
                        </v-btn>
                        <v-btn v-if="$allowed('gm.conduct')" color="error" elevation="0" @click="confirmInterruption" :loading="interruptionDialog.loading">
                            {{ interruptionDialog.type === 3 ? 'Suspender' : 'Interromper' }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

                    <!-- Simulacao antes da abertura: credenciados como se estivessem presentes -->
                    <ui-section v-if="!page.isNew && installationPreview" title="Prévia da instalação"
                        description="Simulação com os credenciamentos até agora, considerando que todos os credenciados como credor compareçam. A instalação oficial é apurada pela presença no dia da assembleia.">
                        <template #actions>
                            <v-btn small outlined color="primary" :loading="previewRefreshing" @click="refreshInstallationPreview">
                                <v-icon left small>mdi-refresh</v-icon> Atualizar
                            </v-btn>
                        </template>
                        <div class="install-preview">
                            <div class="install-preview__card" :class="installationPreview.would_install ? 'install-preview__card--ok' : 'install-preview__card--fail'">
                                <v-icon :color="installationPreview.would_install ? 'success' : 'error'">{{ installationPreview.would_install ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}</v-icon>
                                <div>
                                    <span class="ui-label">Com os credenciamentos aprovados</span>
                                    <strong>{{ installationPreview.would_install ? 'A assembleia seria instalada' : 'A assembleia não seria instalada' }}</strong>
                                    <span class="ui-small ui-muted">{{ installationPreview.total_accredited }} credor(es) credenciado(s) como credor</span>
                                </div>
                            </div>
                            <div v-if="installationPreview.total_pending" class="install-preview__card" :class="installationPreview.would_install_with_pending ? 'install-preview__card--ok' : 'install-preview__card--fail'">
                                <v-icon :color="installationPreview.would_install_with_pending ? 'success' : 'error'">{{ installationPreview.would_install_with_pending ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}</v-icon>
                                <div>
                                    <span class="ui-label">Se os {{ installationPreview.total_pending }} em análise forem aprovados</span>
                                    <strong>{{ installationPreview.would_install_with_pending ? 'A assembleia seria instalada' : 'A assembleia não seria instalada' }}</strong>
                                    <span class="ui-small ui-muted">credenciamentos pendentes ou em regularização</span>
                                </div>
                            </div>
                        </div>
                        <v-alert v-if="!installationPreview.requires_quorum" dense text type="info" class="mb-0">
                            Em 2ª convocação a assembleia se instala com qualquer número de credores presentes.
                        </v-alert>
                        <v-simple-table v-else dense class="quorum-table">
                            <thead>
                                <tr>
                                    <th>Classe</th>
                                    <th class="text-right">Crédito da classe</th>
                                    <th class="text-right">Credenciado (aprovado)</th>
                                    <th class="text-right">Falta para mais da metade</th>
                                    <th class="text-right">Com os em análise</th>
                                    <th class="text-center">Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in installationPreview.classes" :key="`preview-${item.class_id}`">
                                    <td>{{ item.class_name }}</td>
                                    <td class="text-right">{{ item.applies ? formatMoney(item.total_amount) : '—' }}<div v-if="item.applies" class="text-caption ui-muted">{{ item.total_creditors }} credor(es)</div></td>
                                    <td class="text-right">
                                        <template v-if="item.applies">{{ formatPercent(item.accredited_percentage) }}<div class="text-caption ui-muted">{{ formatMoney(item.accredited_amount) }} · {{ item.accredited_creditors }} credor(es)</div></template>
                                        <span v-else>—</span>
                                    </td>
                                    <td class="text-right">{{ item.applies ? (item.missing_amount > 0 ? formatMoney(item.missing_amount) : 'Atingido') : '—' }}</td>
                                    <td class="text-right">
                                        <template v-if="item.applies && item.pending_creditors">{{ formatPercent(item.with_pending_percentage) }}<div class="text-caption" :class="item.reached_with_pending ? 'success--text' : 'ui-muted'">+ {{ item.pending_creditors }} em análise · {{ item.reached_with_pending ? 'atingiria' : 'não atingiria' }}</div></template>
                                        <span v-else>—</span>
                                    </td>
                                    <td class="text-center">
                                        <ui-badge v-if="!item.applies" text="Sem créditos" tone="neutral" />
                                        <ui-badge v-else :text="item.reached ? 'Atinge o quórum' : 'Não atinge'" :tone="item.reached ? 'success' : 'danger'" />
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <p v-if="installationPreview.requires_quorum" class="ui-small ui-muted mt-2 mb-0">
                            1ª convocação: instala com credores titulares de mais da metade dos créditos de cada classe, por valor (art. 37, § 2º, da Lei 11.101/2005).
                        </p>
                    </ui-section>

                    <ui-section v-if="!page.isNew" title="Presença">
                        <template #actions>
                            <v-btn color="primary" outlined small @click="goToPresence()">
                                <v-icon left small>mdi-account-check-outline</v-icon> Gerenciar Presença
                            </v-btn>
                        </template>
                            <v-alert v-if="dataset.data.quorum" dense text :type="dataset.data.quorum.can_install ? 'success' : 'info'" class="mb-4">
                                <template v-if="dataset.data.quorum.installation_snapshot">
                                    <strong>Instalação registrada.</strong> O quadro da instalação está preservado. As presenças abaixo são da sessão atual.
                                </template>
                                <template v-else>
                                    <strong>{{ dataset.data.quorum.convocation_label }}.</strong>
                                    {{ dataset.data.quorum.quorum_rule }}
                                    <span v-if="dataset.data.quorum.requires_quorum"> {{ installationSummary }}.</span>
                                    <span v-else-if="!dataset.data.quorum.installation_inherited && !dataset.data.quorum.can_install"> Aguardando confirmação de presença.</span>
                                </template>
                            </v-alert>
                            <div v-if="dataset.data.quorum" class="d-flex flex-wrap mb-4" style="gap: 8px">
                                <v-btn small outlined color="primary" @click="openInstallationHistory">Quadro da instalação e histórico</v-btn>
                                <v-btn v-if="(!dataset.data.quorum.installation_inherited && !dataset.data.quorum.installation_snapshot) && $allowed('gm.installation')" small color="primary" :loading="installationSaving" :disabled="!dataset.data.quorum.can_install" @click="registerInstallation">Registrar instalação</v-btn>
                                <span v-if="dataset.data.quorum.installation_snapshot" class="text-caption align-self-center">
                                    Instalação registrada em {{ formatHistoryDate(dataset.data.quorum.installation_snapshot.recorded_at) }}
                                    <template v-if="dataset.data.quorum.installation_snapshot.redo"> · refeita {{ dataset.data.quorum.installation_snapshot.redo.count }}x</template>
                                </span>
                                <v-btn v-if="!dataset.data.quorum.installation_inherited && dataset.data.quorum.installation_snapshot" small outlined color="warning" @click="openRedoInstallation">
                                    <v-icon left small>mdi-restore</v-icon>Refazer instalação
                                </v-btn>
                            </div>
                            <v-alert v-if="dataset.data.quorum && dataset.data.quorum.installation_missing" type="warning" text dense>Quadro histórico da instalação não registrado. Os dados atuais não substituem a presença do dia da instalação.</v-alert>
                            <v-alert v-if="dataset.data.quorum && dataset.data.quorum.installation_inherited" type="info" text dense>Podem participar os credores presentes na instalação da AGC, mesmo que tenham faltado a prosseguimentos anteriores. Confirme a presença nesta sessão.</v-alert>
                            <v-dialog v-model="redoInstallation.open" max-width="560" persistent>
                                <v-card class="ui-card">
                                    <div class="ui-card__header"><h3 class="ui-section-title">Refazer instalação</h3></div>
                                    <div class="ui-card__body">
                                        <p class="mb-3">
                                            O quadro da instalação será <strong>substituído</strong> por um novo, calculado agora com as presenças marcadas nesta sessão.
                                            Corrija as presenças antes de refazer.
                                        </p>
                                        <div v-if="dataset.data.quorum && dataset.data.quorum.installation_snapshot" class="redo-installation__compare mb-3">
                                            <div><span class="ui-muted">Quadro atual</span><strong>{{ dataset.data.quorum.installation_snapshot.total_present }} presente(s)</strong><span class="ui-muted">registrado em {{ formatHistoryDate(dataset.data.quorum.installation_snapshot.recorded_at) }}</span></div>
                                            <v-icon>mdi-arrow-right</v-icon>
                                            <div><span class="ui-muted">Novo quadro</span><strong>{{ displayedTotalPresent }} presente(s)</strong><span class="ui-muted">presenças marcadas agora</span></div>
                                        </div>
                                        <p class="ui-small ui-muted mb-3">
                                            O quadro anterior fica guardado no histórico, com o motivo e quem refez. Só é possível enquanto a sessão está aberta e sem prosseguimento criado.
                                        </p>
                                        <v-textarea v-model="redoInstallation.reason" outlined dense rows="3" auto-grow hide-details="auto" label="Motivo (obrigatório)" />
                                    </div>
                                    <div class="ui-card__footer">
                                        <v-btn text :disabled="redoInstallation.saving" @click="redoInstallation.open = false">Cancelar</v-btn>
                                        <v-btn v-if="$allowed('gm.installation')" color="warning" depressed :loading="redoInstallation.saving" :disabled="String(redoInstallation.reason || '').trim().length < 5" @click="confirmRedoInstallation">Refazer instalação</v-btn>
                                    </div>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="installationDialog" max-width="1200" scrollable>
                                <v-card>
                                    <v-card-title>Quadro da instalação e histórico<v-spacer/><v-btn icon aria-label="Fechar histórico" @click="installationDialog = false"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
                                    <v-card-text>
                                        <v-tabs v-model="installationTab"><v-tab>Instalação</v-tab><v-tab>Sessões anteriores</v-tab><v-tab>Acessos à reunião</v-tab></v-tabs><v-tabs-items v-model="installationTab">
                                            <v-tab-item>
                                                <template v-if="dataset.data.quorum && dataset.data.quorum.installation_snapshot">
                                                    <p class="mt-4">{{ dataset.data.quorum.installation_snapshot.meeting_name }} · {{ dataset.data.quorum.installation_snapshot.convocation_label }}<br/>Registrada em {{ formatHistoryDate(dataset.data.quorum.installation_snapshot.recorded_at) }}. Quadro fixo, preservado no momento do registro.</p>
                                                    <v-alert v-if="dataset.data.quorum.installation_snapshot.redo" dense text type="warning" class="mb-3">
                                                        Instalação refeita {{ dataset.data.quorum.installation_snapshot.redo.count }}x. Último motivo: {{ dataset.data.quorum.installation_snapshot.redo.reason }}.
                                                        <template v-if="dataset.data.quorum.installation_snapshot.redo.previous_recorded_at">
                                                            O quadro anterior (registrado em {{ formatHistoryDate(dataset.data.quorum.installation_snapshot.redo.previous_recorded_at) }}, {{ dataset.data.quorum.installation_snapshot.redo.previous_total_present }} presente(s)) ficou guardado no histórico.
                                                        </template>
                                                    </v-alert>
                                                    <v-simple-table dense><thead><tr><th>Classe</th><th>Presentes / total</th><th>Crédito presente / total</th><th>%</th></tr></thead><tbody><tr v-for="row in dataset.data.quorum.installation_snapshot.classes" :key="row.class_id"><td>{{ row.class_name }}</td><td>{{ row.present_creditors }} / {{ row.total_creditors }}</td><td>{{ formatMoney(row.present_amount) }} / {{ formatMoney(row.total_amount) }}</td><td>{{ formatPercent(row.present_amount_percentage) }}</td></tr></tbody></v-simple-table>
                                                    <h3 class="mt-6 mb-2">Credores no quadro da instalação</h3>
                                                    <v-simple-table dense><thead><tr><th>Credor</th><th>Classe</th><th>Crédito</th><th>Presença</th><th>Procurador</th></tr></thead><tbody><tr v-for="row in sortBoardCreditors(dataset.data.quorum.installation_snapshot.creditors)" :key="row.id"><td>{{ row.name }}</td><td>{{ row.class_id }}</td><td>{{ formatMoney(row.amount) }}</td><td>{{ row.present ? 'Presente' : 'Ausente' }}</td><td>{{ row.procurator_name || '—' }}</td></tr></tbody></v-simple-table>
                                                </template>
                                                <v-alert v-else text type="info" class="mt-4">Não há quadro fixo registrado. Não é possível reconstruir automaticamente a instalação histórica com os dados atuais.</v-alert>
                                            </v-tab-item>
                                            <v-tab-item>
                                                <v-progress-linear v-if="installationHistoryLoading" indeterminate/>
                                                <v-alert v-else-if="installationHistoryError" text type="error">Não foi possível carregar o histórico.</v-alert>
                                                <v-alert v-else-if="!installationHistory.length" text type="info" class="mt-4">Nenhuma sessão encerrada com quadro de presenças registrado.</v-alert>
                                                <section v-for="session in installationHistory" :key="session.id" class="mt-4">
                                                    <h3>{{ session.name }}</h3><p>Presenças preservadas em {{ formatHistoryDate(session.recorded_at) }}</p>
                                                    <v-simple-table dense><thead><tr><th>Credor</th><th>Classe</th><th>Crédito</th><th>Presença</th></tr></thead><tbody><tr v-for="row in sortBoardCreditors(session.creditors)" :key="row.id"><td>{{ row.name }}</td><td>{{ row.class_id }}</td><td>{{ formatMoney(row.amount) }}</td><td>{{ row.present ? 'Presente' : 'Ausente' }}</td></tr></tbody></v-simple-table>
                                                </section>
                                            </v-tab-item>
                                            <v-tab-item><meeting-access-logs :meeting-id="dataset.data.id" /></v-tab-item>
                                        </v-tabs-items>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                            <v-alert v-if="blockedCreditors.length" dense text type="warning" class="mb-3">
    <strong>{{ blockedCreditors.length }} credor(es) impedido(s) nesta sessão</strong> por ausência em sessão anterior:
    {{ blockedCreditors.slice(0, 5).map((item) => item.name).join(', ') }}<span v-if="blockedCreditors.length > 5"> e mais {{ blockedCreditors.length - 5 }}</span>.
    A lista completa, com o motivo de cada um, está na lista de presença.
</v-alert>
<div class="mb-4">
<div class="d-flex justify-space-between align-end mb-1">
<span class="font-weight-medium text-caption ui-muted">
Presenças da sessão atual
                                        <span class="ui-muted">(base: {{ creditBaseLabel }})</span>
                                    </span>
                                    <span class="text-caption font-weight-bold">
                                        {{ displayedTotalPresent }} de {{ dataset.data.total_creditors }} ({{ presencePercentage }}%)
                                    </span>
                                </div>
                                <v-progress-linear
                                    :value="presencePercentage"
                                    height="8"
                                    rounded
                                    color="success"
                                    background-opacity="0.3"
                                ></v-progress-linear>
                            </div>

                            <div v-if="quorumClasses.length" class="d-flex justify-end mb-1" style="gap: 8px;">
                                <v-btn x-small outlined color="primary" @click="downloadPresenceCharts()">
                                    <v-icon left x-small>mdi-download</v-icon> Baixar PNG
                                </v-btn>
                                <v-btn x-small elevation="0" color="primary" @click="presenceProjectionDialog = true">
                                    <v-icon left x-small>mdi-projector-screen-outline</v-icon> Projetar
                                </v-btn>
                            </div>
                            <v-row v-if="quorumClasses.length" class="mb-2">
                                <v-col cols="12" md="6">
                                    <div class="text-caption font-weight-medium ui-muted mb-1">
                                        Presença por classe <span class="ui-muted">(credores)</span>
                                    </div>
                                    <highcharts ref="presenceChart" :options="presenceChartOptions"></highcharts>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="text-caption font-weight-medium ui-muted mb-1">
                                        Instalação por classe
                                        <span v-if="installationSource" class="ui-muted">(apurada na sessão "{{ installationSource.name }}")</span>
                                        <span v-else class="ui-muted">(% do crédito presente)</span>
                                    </div>
                                    <highcharts ref="installationChart" :options="installationChartOptions"></highcharts>
                                </v-col>
                            </v-row>

                            <!-- Modo projecao dos graficos de presenca e instalacao -->
                            <v-dialog v-model="presenceProjectionDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                                <v-card style="background: #FFFFFF;">
                                    <v-toolbar flat dense color="white">
                                        <v-toolbar-title style="font-size: 16px; font-weight: 700;">{{ dataset.data.name }} · Presença e instalação</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="downloadPresenceCharts(true)"><v-icon left small>mdi-download</v-icon> Baixar PNG</v-btn>
                                        <v-btn icon @click="presenceProjectionDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                                    </v-toolbar>
                                    <v-card-text style="padding: 24px 40px;">
                                        <div class="text-center mb-4 agc-projection-summary">
                                            {{ displayedTotalPresent }} de {{ dataset.data.total_creditors }} credores presentes ({{ presencePercentage }}%)
                                            <span v-if="dataset.data.quorum" class="agc-projection-status" :class="dataset.data.quorum.requires_quorum ? (dataset.data.quorum.can_install ? 'agc-projection-status--ok' : 'agc-projection-status--fail') : 'ui-muted'">
                                                {{ installationSummary }}
                                            </span>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6"><div class="agc-projection-chart-title">Presença por classe (credores)</div><highcharts ref="projPresence" :options="{ ...presenceChartOptions, chart: { ...presenceChartOptions.chart, height: 460, backgroundColor: '#FFFFFF' } }"></highcharts></v-col>
                                            <v-col cols="12" md="6"><div class="agc-projection-chart-title">Instalação por classe {{ installationSource ? '(apurada na sessão "' + installationSource.name + '")' : '(% do crédito presente)' }}</div><highcharts ref="projInstallation" :options="{ ...installationChartOptions, chart: { ...installationChartOptions.chart, height: 460, backgroundColor: '#FFFFFF' } }"></highcharts></v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>

                            <v-alert
                                v-if="dataset.data.quorum && dataset.data.quorum.requires_quorum && !dataset.data.quorum.can_install"
                                type="warning"
                                text
                                dense
                                class="mb-4"
                            >
                                A primeira convocação ainda não possui quórum de instalação em todas as classes aplicáveis: é preciso mais da metade dos créditos de cada classe, por valor.
                            </v-alert>

                            <div v-if="quorumClasses.length" class="mb-4">
                                <div class="d-flex justify-space-between align-center mb-2">
                                    <span class="text-caption font-weight-medium ui-muted">
                                        Quórum por classe
                                    </span>
                                    <span v-if="presenceAutoRefresh.updatedAt" class="text-caption ui-muted">
                                        Atualizado às {{ formatClock(presenceAutoRefresh.updatedAt) }}
                                    </span>
                                </div>
                                <v-simple-table dense class="quorum-table">
                                    <template #default>
                                        <thead>
                                            <tr>
                                                <th>Classe</th>
                                                <th class="text-right">Credenciados</th>
                                                <th class="text-right">Presentes</th>
                                                <th class="text-right">% crédito<span v-if="installationSource" class="ui-muted"> (instalação)</span></th>
                                                <th v-if="!dataset.data.quorum.installation_inherited && !dataset.data.quorum.installation_snapshot" class="text-center">Quórum para instalação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in quorumClasses" :key="item.class_id">
                                                <td>{{ item.class_name }}</td>
                                                <td class="text-right">
                                                    {{ item.accredited_creditors }} / {{ item.total_creditors }}
                                                </td>
                                                <td class="text-right">
                                                    {{ item.present_creditors }} / {{ item.total_creditors }}
                                                    <div class="text-caption ui-muted">
                                                        {{ formatMoney(item.present_amount) }} / {{ formatMoney(item.total_amount) }}
                                                    </div>
                                                </td>
                                                <td class="text-right">{{ formatPercent(item.present_amount_percentage) }}</td>
                                                <td v-if="!dataset.data.quorum.installation_inherited && !dataset.data.quorum.installation_snapshot" class="text-center">
                                                    <ui-badge :text="getQuorumClassText(installationClassFor(item))" :color="getQuorumClassColor(installationClassFor(item))" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>

                            <v-alert type="info" text dense class="mb-0">
                                Acesse a lista de credores para gerenciar as presenças e ausências nesta assembleia.
                            </v-alert>
                            <!-- Publicada automaticamente ao iniciar a sessao (sem votos) -->
                            <v-alert v-if="dataset.data.presence_list_published_at" type="success" text dense class="mt-3 mb-0">
                                Lista de presenças publicada no site em {{ dataset.data.presence_list_published_at | defaultDate('DD/MM/YYYY HH:mm') }} BRT.
                                <a :href="publicPresenceListUrl" target="_blank" rel="noopener" class="ml-1">Abrir PDF público</a>
                            </v-alert>
                            <v-alert v-else type="info" text dense class="mt-3 mb-0">
                                A lista de presenças é publicada no site automaticamente quando a sessão for iniciada.
                            </v-alert>
                    </ui-section>

                    <ui-section v-if="!page.isNew" title="Credenciamentos" flush>
                        <template #actions>
                            <!-- Lista separada de ouvintes: nao entram na lista de presenca -->
                            <v-btn-toggle v-model="dataAccreditations.participation" dense mandatory color="primary" @change="onAccreditationParticipationChange">
                                <v-btn small value="">Todos</v-btn>
                                <v-btn small :value="1">Credores</v-btn>
                                <v-btn small :value="2">Ouvintes</v-btn>
                            </v-btn-toggle>
                            <v-btn v-if="(dataAccreditations.selected.length) && $allowed('delete')" small outlined color="error"
                                @click="openAccreditationDeletion">
                                <v-icon left small>mdi-delete-outline</v-icon>
                                Remover credenciamento ({{ dataAccreditations.selected.length }})
                            </v-btn>
                            <!-- Credenciamento validado vale para as proximas AGCs do caso -->
                            <v-btn v-if="canCarryOverAccreditations" small outlined color="primary" :loading="dataAccreditations.carrying"
                                @click="carryOverAccreditations">
                                <v-icon left small>mdi-transfer-down</v-icon> Trazer credenciamentos validados
                            </v-btn>
                            <v-btn small outlined color="primary" @click="generateCSV()">
                                <v-icon left small>mdi-file-excel-outline</v-icon> Exportar para Excel
                            </v-btn>
                        </template>
                            <div class="px-5 pt-4">
                                <v-text-field v-model="dataAccreditations.term" prepend-inner-icon="mdi-magnify" clearable outlined dense hide-details
                                    placeholder="Buscar por credor, CPF/CNPJ, e-mail ou procurador" class="accreditation-search"
                                    @input="onAccreditationSearch" />
                            </div>
                            <div v-if="dataset.data.accreditation_availability" class="px-5 pt-4">
                                <v-alert :type="accreditationAvailabilityType" text dense class="mb-0">
                                    <strong>{{ accreditationAvailabilityMessage }}</strong>
                                    <span v-if="dataset.data.accreditation_starts_at || dataset.data.accreditation_ends_at" class="d-block mt-1">
                                        Período: {{ dataset.data.accreditation_starts_at ? formatDateTime(dataset.data.accreditation_starts_at) : 'imediato' }}
                                        até {{ dataset.data.accreditation_ends_at ? formatDateTime(dataset.data.accreditation_ends_at) : 'sem encerramento programado' }}.
                                    </span>
                                </v-alert>
                            </div>

                            <v-data-table
                                v-model="dataAccreditations.selected"
                                show-select
                                item-key="id"
                                :headers="dataAccreditations.headers"
                                :items="dataAccreditations.data"
                                :server-items-length="dataAccreditations.count"
                                disable-sort
                                hide-default-footer
                                :loading="dataAccreditations.loading"
                                no-data-text="Nenhum credenciamento foi encontrado"
                                loading-text="Carregando dados..."
                                class="ui-clickable-rows"
                                :options.sync="dataAccreditations.options"
                                @click:row="viewItem">

                                <template v-slot:[`item.accreditation.user.name`]="{ item }">
                                    <span class="ui-cell-main">{{ item.accreditation.user.name }}</span>
                                </template>

                                <template v-slot:[`item.procurator_name`]="{ item }">
                                    <span :class="{ 'ui-muted': !item.procurator_name }">{{ item.procurator_name || 'N/A' }}</span>
                                </template>

                                <template v-slot:[`item.created_at`]="{ item }">
                                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm [BRT]") }}
                                </template>

                                <template v-slot:[`item.participation_type`]="{ item }">
                                    <span>{{ getParticipationTypeLabel(item.participation_type) }}</span>
                                </template>

                                <template v-slot:[`item.qgc_class`]="{ item }">
                                    <div v-if="item.qgc_credits && item.qgc_credits.length">
                                        <div v-for="credit in item.qgc_credits" :key="`class-${credit.id}`">
                                            {{ getCreditorClassLabel(credit.class) }}
                                        </div>
                                    </div>
                                    <span v-else class="ui-muted">N/A</span>
                                </template>

                                <template v-slot:[`item.qgc_amount`]="{ item }">
                                    <div v-if="item.qgc_credits && item.qgc_credits.length" class="text-right">
                                        <div v-for="credit in item.qgc_credits" :key="`amount-${credit.id}`">
                                            {{ formatCreditAmount(credit.amount, credit.currency) }}
                                        </div>
                                    </div>
                                    <span v-else class="ui-muted">N/A</span>
                                </template>

                                <template v-slot:[`item.source`]="{ item }">
                                    <ui-badge :text="getAccreditationSourceLabel(item.source)" :color="getAccreditationSourceColor(item.source)" />
                                    <v-tooltip v-if="item.carried_from" bottom>
                                        <template #activator="{ on }">
                                            <div class="carried-from" v-on="on">Validado na {{ item.carried_from.label }}</div>
                                        </template>
                                        <span>{{ item.carried_from.name }} · {{ item.carried_from.date | defaultDate("DD/MM/YYYY") }}</span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:[`item.status`]="{ item }">
                                    <ui-badge :text="$options.filters.enum(item.status, dataset.accreditationStatus, 'id', 'name')" :color="getColorByStatus(item.status)" />
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    <ui-row-actions :actions="[
                                        { text: 'Detalhes do credenciamento', icon: 'mdi-pencil-outline', handler: () => viewItem(item) },
                                        { text: 'Excluir credenciamento', icon: 'mdi-delete-outline', handler: () => openSingleDeletion(item), danger: true , disabled: !$allowed('delete') },
                                    ]" />
                                </template>

                                <template #footer>
                                    <ui-pagination
                                        :total="dataAccreditations.count"
                                        :page="dataAccreditations.options.page"
                                        :items-per-page="dataAccreditations.options.itemsPerPage"
                                        :disabled="dataAccreditations.loading"
                                        @update:page="pageChanged"
                                        @update:itemsPerPage="pageSizeChanged"
                                    />
                                </template>
                            </v-data-table>
                    </ui-section>

            <accreditation-delete-dialog
                v-model="singleDeletion.show"
                :item="singleDeletion.item"
                @deleted="loadAccreditations"
            />

            <v-dialog v-model="accreditationDeletion.show" max-width="720px" persistent>
                <v-card>
                    <v-card-title class="modal-title d-flex justify-space-between align-center">
                        <span>Remover credenciamento</span>
                        <v-btn icon @click="closeAccreditationDeletion" :disabled="accreditationDeletion.loading"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-alert type="warning" text dense>
                            A remoção é lógica, não envia e-mail de rejeição e fica registrada com o administrador e a justificativa.
                        </v-alert>
                        <v-alert v-if="accreditationDeletion.preview && !accreditationDeletion.preview.can_delete" type="error" text dense>
                            Há registros com votos, presenças ou substabelecimentos. Esses itens não podem ser removidos.
                        </v-alert>
                        <v-simple-table v-if="accreditationDeletion.preview">
                            <template #default>
                                <thead><tr><th>Credor</th><th>Vínculos</th><th>Situação</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in accreditationDeletion.preview.records" :key="item.id">
                                        <td><strong>{{ item.name }}</strong><div class="text-caption">{{ item.registration }}</div></td>
                                        <td>{{ item.dependencies.votes }} voto(s), {{ item.dependencies.presences }} presença(s), {{ item.dependencies.substitutions }} substabelecimento(s)</td>
                                        <td><ui-badge :text="item.can_delete ? 'Pode remover' : 'Bloqueado'" :tone="item.can_delete ? 'success' : 'danger'" /></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-textarea class="mt-4" dense outlined rows="3" label="Justificativa obrigatória"
                            v-model="accreditationDeletion.reason" hide-details="auto"></v-textarea>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="closeAccreditationDeletion" :disabled="accreditationDeletion.loading">Cancelar</v-btn>
                        <v-btn v-if="$allowed('delete')" color="error" elevation="0" @click="confirmAccreditationDeletion"
                            :loading="accreditationDeletion.loading"
                            :disabled="!accreditationDeletion.preview || !accreditationDeletion.preview.can_delete || !accreditationDeletion.reason.trim()">
                            Remover credenciamento
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-form>

        <v-dialog v-model="convert.open" max-width="620" persistent>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <div>
                        <h3 class="ui-section-title">Transformar em prosseguimento</h3>
                        <p class="ui-section-description">Liga esta AGC à sessão anterior como faz "Suspender Assembleia": herda a instalação, quem pode continuar e o histórico. Zoom, descrição e o que já foi configurado aqui são mantidos.</p>
                    </div>
                </div>
                <div class="ui-card__body">
                    <v-select v-model="convert.source" :items="installedSessions" item-value="id" item-text="text" label="Sessão que continua nesta AGC"
                        outlined dense hide-details="auto" class="mb-4" :menu-props="{ offsetY: true }"></v-select>
                    <v-textarea v-model="convert.reason" label="Motivo da suspensão da sessão anterior" outlined dense rows="3" hide-details="auto"></v-textarea>
                    <p class="ui-small ui-muted mt-3 mb-0">A sessão anterior passa a "Suspensa", com este motivo e a data desta AGC como continuação. Credenciamentos de quem estava presente na instalação são trazidos; quem já tem pedido aqui não é alterado.</p>
                </div>
                <div class="ui-card__footer">
                    <v-btn outlined :disabled="convert.loading" @click="convert.open = false">Cancelar</v-btn>
                    <v-btn color="primary" depressed :loading="convert.loading" :disabled="!convert.source || !convert.reason.trim()" @click="confirmConvert">Transformar</v-btn>
                </div>
            </v-card>
        </v-dialog>

	        <general-meeting-notice-file-upload ref="fileUploadDialogRef"></general-meeting-notice-file-upload>
	        <accreditation-details-modal ref="accreditationDetailsModalRef"></accreditation-details-modal>
	        <general-meeting-comments-modal ref="generalMeetingCommentsModalRef"></general-meeting-comments-modal>
	
	    </div>
</template>

<script>
import MeetingAccessLogs from '@/components/general-meeting/MeetingAccessLogs.vue';
import { downloadChartPng } from "@/common/util/chart-export.util";
import { downloadXlsx } from "@/common/util/export-xlsx.util";
import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from "axios"
import object from "@/common/util/object"

import states from "@/common/data/states.data"
import string from "@/common/util/string"
import eventStatus from "@/common/data/event-status.data";
import accreditationStatus from "@/common/data/accreditation-status.data";
import agcVotingStatus from "@/common/data/agc-voting-status.data";
import agcVotingTypes from "@/common/data/agc-voting-types.data";
import agcConvocationTypes from "@/common/data/agc-convocation-types.data";
import creditorTypes from "@/common/data/creditor-types.data";
import creditorClassUtil from "@/common/util/creditor-class.util";
import currencyTypes from "@/common/data/currency-types.data";

import AccreditationDetailsModal from "@/components/AccreditationDetailsModal.vue";
import AccreditationDeleteDialog from "@/components/AccreditationDeleteDialog.vue";
import GeneralMeetingCommentsModal from "@/components/GeneralMeetingCommentsModal.vue";
import GeneralMeetingNoticeFileUpload from '@/components/GeneralMeetingNoticeFileUpload.vue';
import AIAnalysisButton from "@/components/AIAnalysisButton.vue";

import { eventHub } from "@/main";
import { cpf, cnpj } from 'cpf-cnpj-validator'

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Link, Paragraph
} from 'tiptap-vuetify'

Vue.use(VueLodash)

export default {
    name: "GeneralMeetingDetails",

	    components: { 
            MeetingAccessLogs,
	        'tiptap-vuetify': TiptapVuetify,
	        AccreditationDeleteDialog,
	        'accreditation-details-modal': AccreditationDetailsModal,
	        'general-meeting-comments-modal': GeneralMeetingCommentsModal,
	        'general-meeting-notice-file-upload': GeneralMeetingNoticeFileUpload,
	        'ai-analysis-button': AIAnalysisButton
	    },

    data: () => ({
        presenceProjectionDialog: false,
        blockedCreditors: [],
        installationDialog: false,
        installationTab: 0,
        installationSaving: false,
        redoInstallation: { open: false, saving: false, reason: '' },
        installationHistory: [],
        installationHistoryLoading: false,
        installationHistoryError: false,
        page: {
            isNew: false,
            title: "",
        },
        previewRefreshing: false,
        presenceAutoRefresh: {
            timer: null,
            intervalMs: 30000,
            updatedAt: null,
            refreshing: false
        },
        // Sessoes do caso (aviso de prosseguimento e conversao de AGC avulsa).
        caseSessions: [],
        convert: { open: false, source: null, reason: "", loading: false },
        dataset: {
            breadcrumbItems: [],
            loading: true, 
            convocationTypes: agcConvocationTypes,
            data: {
                id: null,
                name: '',
                convocation_type: 1,
                date: null,
                next_convocation_date: null,
                client_id: null,
                description: '',
                status: null,
                votingExist: false,
                client: { name: '' },
                totalDiffPercentage: 0,
                totalDiff: 0,
                total_creditors: 0,
                total_present: 0,
                total_accredited: 0,
                quorum: null,
                notices: [],
                zoom_enabled: false,
                zoom_auto_create: true,
                zoom_type: "meeting",
                zoom_host_id: "",
                zoom_meeting_id: "",
                zoom_join_url: "",
                zoom_duration: 240,
                zoom_status: null,
                zoom_last_synced_at: null,
                exchange_rate_usd: null,
                exchange_rate_eur: null,
                exchange_rate_date: null,
                // Nova assembleia nasce com credenciamento pelo site desligado; o
                // administrador liga quando definir o periodo.
                accreditation_enabled: false,
                accreditation_starts_at: null,
                accreditation_ends_at: null,
                accreditation_closed_at: null,
                accreditation_availability: null,
                parent_general_meeting_id: null,
                continuation_number: 1
            },
            clients: [],
            accreditationStatus: accreditationStatus,
            creditorTypes: creditorTypes,
            currencyTypes: currencyTypes,
        },
	        dataForm: {
	            validForm: true,
	            addLoading: false,
	            updateLoading: false,
	        },
            zoom: {
                loading: false,
                syncLoading: false,
                lastSyncMessage: "",
                types: [
                    { id: "meeting", name: "Meeting" },
                    { id: "webinar", name: "Webinar (planejado)" },
                ],
            },
	        interruptionDialog: {
	            show: false,
	            loading: false,
	            id: null,
	            type: 7,
	            status: 2,
	            nextConvocationDate: "",
	            reason: "",
	            votingReuseMode: "structure",
	        },
	        voting: {
	            items: [],
	            loading: false,
	            statuses: agcVotingStatus,
	            types: agcVotingTypes,
	            headers: [
	                { text: "Nome", value: "name" },
	                { text: "Tipo", value: "type" },
	                { text: "Cenário", value: "scenario" },
	                { text: "Status", value: "status" },
	                { text: "Criado em", value: "created_at" },
	                { text: "", value: "actions", sortable: false, align: "end", width: 56 },
	            ],
	            form: {
	                show: false,
	                isNew: true,
	                valid: true,
	                loading: false,
	                data: {
	                    id: null,
	                    name: "",
	                    description: "",
	                    type: null,
	                    status: 1,
	                    scenario_id: null,
	                    scenario_ids: [],
	                },
	            },
	        },
	        scenario: {
	            dialog: false,
	            loading: false,
	            filter: "",
	            items: [],
	            creditors: [],
	            options: [],
	            headers: [
		                { text: "Sem voto", value: "blocked", width: 100 },
		                { text: "Credor", value: "name" },
		                { text: "CPF/CNPJ", value: "registration" },
		                { text: "Classe", value: "scenario_class" },
		                { text: "Moeda", value: "currency", width: 120 },
		                { text: "Valor", value: "amount" },
		                { text: "Presença", value: "has_presence" },
		                { text: "Ações", value: "actions", sortable: false, width: 80 },
	            ],
	            form: {
	                loading: false,
	                data: {
	                    id: null,
	                    name: "",
	                    blocked_user_creditor_ids: [],
	                    blocked_accreditation_general_meeting_ids: [],
	                    blocked_user_ids: [],
	                },
	            },
	        },
        dataAccreditations: {
            participation: '',
            term: '',
            data: [],
            selected: [],
            loading: false,
            carrying: false,
            count: 0,
            headers: [
                { text: "Nome", value: "accreditation.user.name" },
                { text: "Procurador", value: "procurator_name" },
                { text: "Participação", value: "participation_type" },
                { text: "Classe", value: "qgc_class" },
                { text: "Crédito", value: "qgc_amount", align: "right" },
                { text: "Origem", value: "source", align: "center" },
                { text: "Criado em", value: "created_at" },
                { text: "Status", value: "status" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por pág:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
            },
        },
        // Exclusao de um credenciamento pelo icone da linha, com motivo em editor.
        singleDeletion: {
            show: false,
            item: null,
        },
        accreditationDeletion: {
            show: false,
            loading: false,
            preview: null,
            reason: "",
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Link,
            Paragraph,
        ],
    }),

    watch: {
        "dataset.data.client_id"() {
            this.loadCaseSessions();
        },
        // Desmarcou o cenario base: a votacao passa a usar o QGC do caso.
        "voting.form.data.scenario_ids"(ids) {
            const base = this.voting.form.data.scenario_id;
            if (base && !(ids || []).includes(base)) this.voting.form.data.scenario_id = null;
        },
        // Escolheu um cenario base: ele fica marcado.
        "voting.form.data.scenario_id"(id) {
            const ids = this.voting.form.data.scenario_ids || [];
            if (id && !ids.includes(id)) this.voting.form.data.scenario_ids = [...ids, id];
        },
    },

    computed: {
        // Base da votacao: QGC do caso ou um dos cenarios marcados.
        baseScenarioOptions() {
            const ids = this.voting.form.data.scenario_ids || [];
            return [
                { id: null, name: "Todos os credenciados (QGC do caso)" },
                ...this.scenario.items.filter((item) => ids.includes(item.id)),
            ];
        },
        // Sessoes do caso com instalacao (propria ou herdada), anteriores a esta AGC.
        installedSessions() {
            const current = this.dataset.data || {};
            return this.caseSessions
                .filter((item) => Number(item.id) !== Number(current.id))
                .filter((item) => item.installed_here || item.installation_inherited_from)
                .filter((item) => !current.date || String(item.date) < String(current.date))
                .map((item) => ({ id: item.id, text: `${item.session_label} de ${this.formatDateTime(item.date)}` }));
        },
        continuationWarning() {
            return this.installedSessions.length > 0 || /prosseg/i.test(String(this.dataset.data.name || ""));
        },
        canConvertToContinuation() {
            const data = this.dataset.data || {};
            const installed = data.quorum && data.quorum.installation_snapshot;
            return !this.page.isNew && !this.isContinuationMeeting && Number(data.status) === 0 && !installed && this.installedSessions.length > 0;
        },
        publicPresenceListUrl() {
            const base = String(axios.defaults.baseURL || '').replace(/\/+$/, '');
            return `${base}/api/general-meetings/${this.dataset.data.id}/presence-list`;
        },
        // 1a/2a convocacao ainda nao iniciada pode receber os credenciamentos validados nas AGCs anteriores.
        canCarryOverAccreditations() {
            return !this.isContinuationMeeting && Number(this.dataset.data.status) === 0;
        },
        // Sessao criada pela suspensao (prosseguimento ligado a sessao de origem).
        isContinuationMeeting() {
            const data = this.dataset.data || {};
            return Number(data.convocation_type) === 3 && !!(data.parent_general_meeting_id || data.root_general_meeting_id);
        },
        // No seletor so a 1a e a 2a convocacao: o prosseguimento e sub-opcao delas.
        convocationOptions() {
            return this.dataset.convocationTypes.filter((item) => Number(item.id) !== 3);
        },
        continuationTypeLabel() {
            const origin = this.dataset.convocationTypes.find((item) => Number(item.id) === Number(this.dataset.data.origin_convocation_type));
            const session = this.dataset.data.session_label || 'Prosseguimento';
            return origin ? `${origin.name} · ${session}` : session;
        },
        // Regra de quorum do tipo escolhido no formulario.
        convocationRule() {
            const type = this.dataset.convocationTypes.find((item) => Number(item.id) === Number(this.dataset.data.convocation_type));
            return type ? type.rule : '';
        },

        computedDateInput: {
            get() {
                return this.dataset.data.date ? this.$moment.tz(this.dataset.data.date, 'America/Sao_Paulo').format("YYYY-MM-DDTHH:mm") : "";
            },
            set(value) {
                this.dataset.data.date = value || null;
            },
        },
        computedExchangeRateDateInput() {
            if (!this.dataset.data.exchange_rate_date) return "";
            return this.$moment(this.dataset.data.exchange_rate_date).format("YYYY-MM-DDTHH:mm");
        },
        computedAccreditationStartsAt: {
            get() {
                return this.dataset.data.accreditation_starts_at
                    ? this.$moment(this.dataset.data.accreditation_starts_at).format("YYYY-MM-DDTHH:mm")
                    : "";
            },
            set(value) {
                this.dataset.data.accreditation_starts_at = value || null;
            },
        },
        computedAccreditationEndsAt: {
            get() {
                return this.dataset.data.accreditation_ends_at
                    ? this.$moment(this.dataset.data.accreditation_ends_at).format("YYYY-MM-DDTHH:mm")
                    : "";
            },
            set(value) {
                this.dataset.data.accreditation_ends_at = value || null;
            },
        },
        accreditationAvailabilityMessage() {
            const availability = this.dataset.data.accreditation_availability;
            return availability && availability.message
                ? availability.message
                : "Salve a assembleia para atualizar a disponibilidade do credenciamento.";
        },
        accreditationAvailabilityType() {
            const availability = this.dataset.data.accreditation_availability;
            if (!availability) return "info";
            return availability.is_open ? "success" : "warning";
        },
        exchangeRatesLocked() {
            if (this.isContinuationMeeting) return true;
            return [2, 3, 4, 5].includes(Number(this.dataset.data.status));
        },
        presencePercentage() {
            const present = this.displayedTotalPresent || 0;
            const total = this.dataset.data.total_creditors || 0;
            if (total === 0) return 0;
            
            return Math.min(Math.round((present / total) * 100), 100);
        },
        displayedTotalPresent() {
            const present = Number(this.dataset.data.total_present || 0);
            const total = Number(this.dataset.data.total_creditors || 0);

            if (!total) return present;
            return Math.min(present, total);
        },
        // Base de creditos da assembleia: cenario oficial ou o QGC do caso.
        creditBaseLabel() {
            const base = this.dataset.data.quorum && this.dataset.data.quorum.credit_base;
            if (base && base.type === 'scenario') return `cenário oficial "${base.scenario_name}"`;
            return 'QGC do caso';
        },

        installationClasses() {
            const quorum = this.dataset.data.quorum;
            if (!quorum || quorum.installation_missing) return [];
            if (Array.isArray(quorum.installation_classes) && quorum.installation_classes.length) return quorum.installation_classes;
            return Array.isArray(quorum.classes) ? quorum.classes : [];
        },

        installationSource() {
            const quorum = this.dataset.data.quorum;
            return quorum && quorum.installation_source ? quorum.installation_source : null;
        },

        installationRequiresQuorum() {
            const quorum = this.dataset.data.quorum || {};
            return this.installationSource
                ? Number(this.installationSource.convocation_type) === 1
                : !!quorum.requires_quorum;
        },
        installationSummary() {
            const quorum = this.dataset.data.quorum || {};
            if (quorum.installation_missing) return 'Instalação histórica não registrada';
            if (quorum.installation_snapshot) return 'Instalação registrada';
            if (quorum.installation_inherited) return 'Instalação preservada da sessão de origem';
            if (!quorum.requires_quorum) return quorum.can_install ? 'Quórum mínimo dispensado' : 'Aguardando confirmação de presença';
            return quorum.can_install ? 'Quórum de instalação atingido' : 'Quórum de instalação ainda não atingido';
        },

        // Previa so antes da abertura: sessao aberta, sem instalacao registrada e fora de prosseguimento.
        installationPreview() {
            const quorum = this.dataset.data.quorum;
            if (!quorum || !quorum.installation_preview || quorum.installation_snapshot || quorum.installation_inherited) return null;
            return Number(this.dataset.data.status) === 0 ? quorum.installation_preview : null;
        },
        quorumClasses() {
            const quorum = this.dataset.data.quorum;
            if (!quorum || !Array.isArray(quorum.classes)) return [];

            // Todas as classes do QGC ficam visíveis desde o início, inclusive as
            // ainda sem credores, para que a operação acompanhe o preenchimento.
            return quorum.classes;
        },
        quorumChartCategories() {
            // Rótulo curto para o eixo: "Classe I - Trabalhista" vira "Classe I".
            return this.quorumClasses.map((item) => {
                const name = String(item.class_name || `Classe ${item.class_id}`);
                const separatorIndex = name.indexOf(' - ');
                return separatorIndex > 0 ? name.slice(0, separatorIndex) : name;
            });
        },
        presenceChartOptions() {
            const classes = this.quorumClasses;
            return {
                title: null,
                chart: { type: 'column', backgroundColor: 'transparent', height: 240 },
                credits: { enabled: false },
                legend: { enabled: true, itemStyle: { fontSize: '11px', fontWeight: 'normal' } },
                xAxis: { categories: this.quorumChartCategories, lineColor: '#E5E7EB', tickColor: '#E5E7EB' },
                yAxis: { title: { text: null }, allowDecimals: false, min: 0, gridLineColor: '#F3F4F6' },
                tooltip: { shared: true },
                plotOptions: {
                    column: { borderWidth: 0, borderRadius: 3, groupPadding: 0.15, dataLabels: { enabled: true, style: { fontSize: '10px', fontWeight: 'normal', textOutline: 'none' } } },
                },
                series: [
                    { name: 'No QGC', data: classes.map((item) => Number(item.total_creditors || 0)), color: '#BDBDBD' },
                    { name: 'Credenciados', data: classes.map((item) => Number(item.accredited_creditors || 0)), color: '#7E55AB' },
                    { name: 'Presentes', data: classes.map((item) => Number(item.present_creditors || 0)), color: '#4CAF50' },
                ],
            };
        },
        installationChartOptions() {
            const quorum = this.dataset.data.quorum || {};
            const source = this.installationSource;
            const requiresQuorum = source ? Number(source.convocation_type) === 1 : !!quorum.requires_quorum;
            const classes = this.installationClasses;
            const formatMoney = this.formatMoney;

            const data = classes.map((item) => {
                let color = '#2196F3';
                if (!item.applies) color = '#9E9E9E';
                else if (requiresQuorum && item.fit !== undefined && item.fit !== null) color = item.fit ? '#4CAF50' : '#F44336';
                else if (requiresQuorum) color = item.quorum_reached ? '#4CAF50' : '#F44336';

                return {
                    y: Number(item.present_amount_percentage || 0),
                    color,
                    present_amount: item.present_amount,
                    total_amount: item.total_amount,
                    applies: item.applies,
                };
            });

            return {
                title: null,
                // spacingTop abre espaco para o rotulo da linha do quorum, acima da area do grafico.
                chart: { type: 'bar', backgroundColor: 'transparent', height: 240, spacingTop: 22 },
                credits: { enabled: false },
                legend: { enabled: false },
                xAxis: { categories: this.quorumChartCategories, lineColor: '#E5E7EB', tickColor: '#E5E7EB' },
                yAxis: {
                    title: { text: null },
                    min: 0,
                    max: 100,
                    gridLineColor: '#F3F4F6',
                    labels: { format: '{value}%' },
                    plotLines: requiresQuorum ? [{
                        value: 50,
                        color: '#F44336',
                        width: 2,
                        dashStyle: 'ShortDash',
                        zIndex: 5,
                        // Linha vertical (grafico de barras): o Highcharts rotaciona o rotulo em 90 por padrao
                        // e ele saia pelo topo. Horizontal, centrado na linha, logo acima da area do grafico.
                        label: { text: 'Quórum (> 50%)', rotation: 0, textAlign: 'center', verticalAlign: 'top', y: -8, style: { color: '#F44336', fontSize: '10px', fontWeight: '600' } },
                    }] : [],
                },
                tooltip: {
                    formatter() {
                        const point = this.point;
                        if (!point.applies) return `<b>${this.x}</b><br/>Sem credores no QGC`;
                        return `<b>${this.x}</b><br/>Crédito presente: ${formatMoney(point.present_amount)} de ${formatMoney(point.total_amount)}<br/>(${Number(point.y).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)`;
                    },
                },
                plotOptions: {
                    bar: {
                        borderWidth: 0,
                        borderRadius: 3,
                        dataLabels: {
                            enabled: true,
                            style: { fontSize: '10px', fontWeight: 'normal', textOutline: 'none' },
                            formatter() {
                                return this.point.applies
                                    ? `${Number(this.y).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
                                    : 'Sem credores';
                            },
                        },
                    },
                },
                series: [{ name: '% do crédito presente', data }],
            };
        },
        filteredScenarioCreditors() {
            const term = (this.scenario.filter || "").toLowerCase();
            if (!term) return this.scenario.creditors;

            return this.scenario.creditors.filter((item) => {
                return [item.name, item.email, item.registration]
                    .filter(Boolean)
                    .some((value) => value.toLowerCase().includes(term));
            });
        }
    },

    created() {
        this.setPage();
        this.listBreadCrumbItems();
        this.loadData();

        eventHub.$on('DIALOG-ACCREDITATION-DETAILS', value => {
        });
    },

    mounted() {
        if (!this.page.isNew) this.startPresenceAutoRefresh();
    },

    beforeDestroy() {
        this.stopPresenceAutoRefresh();
    },

    methods: {
        startPresenceAutoRefresh() {
            this.stopPresenceAutoRefresh();

            this.presenceAutoRefresh.timer = setInterval(() => {
                // Evita empilhar requisições e poupa chamadas quando a aba está oculta.
                if (this.presenceAutoRefresh.refreshing) return;
                if (typeof document !== 'undefined' && document.hidden) return;

                this.refreshPresenceStats();
            }, this.presenceAutoRefresh.intervalMs);
        },

        stopPresenceAutoRefresh() {
            if (this.presenceAutoRefresh.timer) {
                clearInterval(this.presenceAutoRefresh.timer);
                this.presenceAutoRefresh.timer = null;
            }
        },

        async refreshPresenceStats() {
            this.presenceAutoRefresh.refreshing = true;

            try {
                await this.loadPresenceStats();
                this.presenceAutoRefresh.updatedAt = new Date();
            } finally {
                this.presenceAutoRefresh.refreshing = false;
            }
        },

        onlyDigits(value) {
            return String(value || '').replace(/\D/g, '');
        },

        formatRegistrationValue(value) {
            const rawValue = this.onlyDigits(value);
            if (!rawValue) return '';
            return rawValue.length > 11 ? cnpj.format(rawValue.slice(0, 14)) : cpf.format(rawValue.slice(0, 11));
        },

        formatMoney(value) {
            return Number(value || 0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },

        formatPercent(value) {
            return `${Number(value || 0).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}%`;
        },

        formatClock(value) {
            if (!value) return '';
            return this.$moment(value).tz('America/Sao_Paulo').format('HH:mm [BRT]');
        },

        // Quadro de presenças: presentes primeiro, depois ausentes, cada grupo em ordem alfabética pelo credor.
        sortBoardCreditors(rows) {
            return (Array.isArray(rows) ? rows.slice() : []).sort((a, b) => {
                if (!!a.present !== !!b.present) return a.present ? -1 : 1;
                return String(a.name || '').localeCompare(String(b.name || ''), 'pt-BR', { sensitivity: 'base' });
            });
        },
        formatHistoryDate(value) {
            return this.$moment(value).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm [BRT]');
        },
        async openInstallationHistory() {
            this.installationDialog = true;
            this.installationHistoryLoading = true;
            this.installationHistoryError = false;
            this.installationHistory = [];
            try {
                const response = await axios.get(`/api/admin/general-meetings/${this.dataset.data.id}/installation-history`);
                this.installationHistory = response.data.content || [];
            } catch (error) { this.installationHistoryError = true; }
            finally { this.installationHistoryLoading = false; }
        },
        openRedoInstallation() {
            this.redoInstallation = { open: true, saving: false, reason: '' };
        },
        async confirmRedoInstallation() {
            this.redoInstallation.saving = true;
            try {
                await axios.post(`/api/admin/general-meetings/${this.dataset.data.id}/installation/redo`, { reason: this.redoInstallation.reason });
                this.redoInstallation.open = false;
                this.$dialog.notify.info('Instalação refeita com as presenças atuais. O quadro anterior ficou no histórico.', { position: 'top-right', timeout: 5000 });
                await this.load();
                await this.loadPresenceStats();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 6000 });
            } finally {
                this.redoInstallation.saving = false;
            }
        },
        async registerInstallation() {
            const confirmed = await this.$dialog.confirm({ title: 'Registrar instalação', text: 'Preservar o quadro de presenças, classes e créditos atuais? O registro terá a data e hora de agora e não poderá ser sobrescrito.', actions: { false: 'Cancelar', true: 'Registrar' } });
            if (!confirmed) return;
            this.installationSaving = true;
            try {
                await axios.post(`/api/admin/general-meetings/${this.dataset.data.id}/installation`, {});
                await this.load();
                await this.loadPresenceStats();
                await this.openInstallationHistory();
            } catch (error) { this.$dialog.notify.error(this.$codes(error)); }
            finally { this.installationSaving = false; }
        },

        async downloadPresenceCharts(fromProjection = false) {
            const refs = fromProjection ? ['projPresence', 'projInstallation'] : ['presenceChart', 'installationChart'];
            const names = ['presenca-por-classe', 'instalacao-por-classe'];
            const base = String(this.dataset.data.name || 'assembleia').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
            for (let i = 0; i < refs.length; i += 1) {
                const component = this.$refs[refs[i]];
                const chart = component && component.chart;
                if (chart) await downloadChartPng(chart, `${base}-${names[i]}`);
            }
        },

        isQuorumClassFit(item) {
            if (item && item.fit !== undefined && item.fit !== null) return !!item.fit;
            const quorum = this.dataset.data.quorum || {};
            if (quorum.requires_quorum) return !!item.quorum_reached;
            return !!quorum.can_install;
        },

        // Dados de instalacao da classe (no prosseguimento, da sessao que instalou).
        installationClassFor(item) {
            const found = this.installationClasses.find((entry) => Number(entry.class_id) === Number(item.class_id));
            return found || item;
        },

        getQuorumClassColor(item) {
            // Classe sem credores no QGC não entra no cálculo de instalação.
            if (!item.applies || !this.installationRequiresQuorum) return 'grey';
            return this.isQuorumClassFit(item) ? 'success' : 'error';
        },

        getQuorumClassText(item) {
            if (!item.applies) return 'Sem credores';
            if (!this.installationRequiresQuorum) return 'Quórum mínimo dispensado';
            return this.isQuorumClassFit(item) ? 'Apto para instalar' : 'Não apto para instalar';
        },

        getAccreditationSourceLabel(source) {
            return Number(source) === 2 ? 'Administrador' : 'Site';
        },

        getAccreditationSourceColor(source) {
            return Number(source) === 2 ? 'primary' : 'success';
        },

        async loadPresenceStats() {
            try {
                const result = await axios.get('/api/admin/general-meetings/list-presence', { 
                    params: { 
                        page: 1, 
                        limit: 10000, 
                        general_meeting_id: this.$route.params.id 
                    } 
                });

                const resultContent = result.data.content || {};
const creditors = resultContent.data || [];
const quorum = resultContent.quorum || null;
this.blockedCreditors = resultContent.blocked || [];
                const totalCreditors = quorum
                    ? quorum.total_creditors
                    : (resultContent.stats ? resultContent.stats.total : (resultContent.paging.total || 0));
                const totalPresent = quorum
                    ? quorum.total_present
                    : (resultContent.stats
                        ? resultContent.stats.present
                        : creditors.filter(item => item.presence !== null).length);

                this.dataset.data.total_creditors = totalCreditors;
                this.dataset.data.total_present = totalPresent;
                this.dataset.data.quorum = quorum;

            } catch (error) {
                console.error("Erro ao carregar estatísticas de presença", error);
            }
        },

        goBack() {
            this.$router.replace("/agcs");
        },

        updateDate(val) {
            this.dataset.data.date = val;
        },
        updateExchangeRateDate(val) {
            this.dataset.data.exchange_rate_date = val;
        },

        // Horarios da assembleia sao digitados em Brasilia; o rotulo BRT deixa isso explicito.
        formatDateTime(value) {
            if (!value || !this.$moment(value).isValid()) return "";
            return this.$moment(value).format("DD/MM/YYYY HH:mm") + " BRT";
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Nova Assembleia" : "Detalhes da Assembleia";
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: "Homepage", disabled: false, to: "/home", exact: true },
                { text: "Assembleias", disabled: false, to: "/agcs", exact: true },
                { text: this.page.title, disabled: true, exact: true },
            ];
        },

        async loadData() {
            this.dataset.loading = true;
            await this.loadClients();

	            if (!this.page.isNew) {
	                await this.load();
	                await this.loadCreditorClasses();
	                await this.loadScenarios();
	                await this.loadVotings();
	                await this.loadAccreditations();
	                await this.loadPresenceStats();
	            } else {
                this.dataset.loading = false;
            }
        },

        async loadCreditorClasses() {
            // Classes usadas nos participantes de cenario de votacao. Inclui as
            // ocultas porque um participante ja cadastrado pode estar numa
            // classe que foi ocultada depois.
            this.dataset.creditorTypes = await creditorClassUtil.listLabels(this.dataset.data.client_id);
        },

        async refreshInstallationPreview() {
            this.previewRefreshing = true;
            try {
                await this.loadPresenceStats();
            } finally {
                this.previewRefreshing = false;
            }
        },

        async load() {
            try {
                const result = await axios.get(`/api/admin/general-meetings/${this.$route.params.id}`);
                
                this.dataset.data = Object.assign({}, this.dataset.data, result.data.content);
                // Prosseguimento antigo criado a mao (sem sessao de origem): obriga a escolher 1a ou 2a.
                if (Number(this.dataset.data.convocation_type) === 3 && !this.isContinuationMeeting) this.dataset.data.convocation_type = null;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { limit: 10000000 } });
                const data = result.data.content.data;
                data.sort((a, b) => a.name.localeCompare(b.name));
                this.dataset.clients = data;
            } catch (error) {
                console.error("Erro ao carregar clientes", error);
            }
        },

        async changeAccreditationAvailability(action) {
            const closing = action === 'close';
            const confirmed = await this.$dialog.confirm({
                title: closing ? 'Encerrar credenciamento' : 'Reabrir credenciamento',
                text: closing
                    ? 'Novos credenciamentos serão bloqueados imediatamente. Substabelecimentos de credores já aprovados continuarão permitidos.'
                    : 'Deseja reabrir manualmente o credenciamento desta assembleia?',
                actions: { false: 'Cancelar', true: closing ? 'Encerrar' : 'Reabrir' },
            });
            if (!confirmed) return;
            try {
                await axios.patch(`/api/admin/general-meetings/${this.dataset.data.id}/accreditation-availability`, { action });
                this.$dialog.notify.info(
                    closing ? 'Credenciamento encerrado.' : 'Credenciamento reaberto.',
                    { position: 'top-right', timeout: 2500 }
                );
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }
        },

        buildZoomPayload(syncZoom = false) {
            const payload = {
                zoom_enabled: !!this.dataset.data.zoom_enabled,
                zoom_auto_create: !!this.dataset.data.zoom_auto_create,
                zoom_type: this.dataset.data.zoom_type || "meeting",
                zoom_duration: this.dataset.data.zoom_duration || 240,
                sync_zoom: syncZoom,
                create_zoom_meeting: syncZoom,
            };

            if (this.dataset.data.zoom_meeting_id) {
                payload.zoom_meeting_id = this.dataset.data.zoom_meeting_id;
            }

            return payload;
        },

        async saveZoom(syncZoom = false) {
            this.zoom.loading = true;
            this.zoom.lastSyncMessage = "";

            try {
                const result = await axios.patch(
                    `/api/admin/general-meetings/${this.dataset.data.id}/zoom`,
                    this.buildZoomPayload(syncZoom)
                );

                this.dataset.data = Object.assign({}, this.dataset.data, result.data.content);
                this.$dialog.notify.success(
                    syncZoom ? "Reunião Zoom sincronizada com sucesso." : "Configuração Zoom salva com sucesso.",
                    { position: "top-right", timeout: 3000 }
                );
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.zoom.loading = false;
            }
        },

        async syncZoomRegistrants() {
            this.zoom.syncLoading = true;
            this.zoom.lastSyncMessage = "";

            try {
                const result = await axios.post(`/api/admin/general-meetings/${this.dataset.data.id}/zoom/sync-registrants`);
                const total = result.data.content.total || 0;
                this.zoom.lastSyncMessage = `${total} link(s) individual(is) sincronizado(s) para esta AGC.`;
                this.$dialog.notify.success(this.zoom.lastSyncMessage, { position: "top-right", timeout: 3000 });
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.zoom.syncLoading = false;
            }
        },

	        async loadAccreditations() {
            this.dataAccreditations.loading = true;
            
            let search = { general_meeting_id: this.$route.params.id };
            if (this.dataAccreditations.participation) search.participation_type = this.dataAccreditations.participation;
            if (this.dataAccreditations.term && this.dataAccreditations.term.trim()) search.term = this.dataAccreditations.term.trim();

            try {
                const result = await axios.get('/api/admin/accreditations', { 
                    params: { 
                        page: this.dataAccreditations.options.page, 
                        limit: this.dataAccreditations.options.itemsPerPage, 
                        search: search 
                    } 
                });

                this.dataAccreditations.data = result.data.content.data;
                this.dataAccreditations.count = result.data.content.paging.total;

            } catch (error) {
                console.error("Erro ao carregar credenciamentos", error);
            } finally {
                this.dataAccreditations.loading = false;
            }
	        },

            async carryOverAccreditations() {
                const confirmed = await this.$dialog.confirm({
                    title: "Trazer credenciamentos validados",
                    text: "Os credenciamentos aprovados nas AGCs anteriores deste caso passam a valer nesta AGC, com os mesmos documentos e procurador. Quem já tem pedido nesta AGC não é alterado.",
                    actions: { false: "Cancelar", true: "Trazer" },
                });
                if (!confirmed) return;
                this.dataAccreditations.carrying = true;
                try {
                    const result = await axios.post(`/api/admin/general-meetings/${this.$route.params.id}/carry-over-accreditations`);
                    const { copied, skipped } = result.data.content;
                    const message = copied
                        ? `${copied} credenciamento(s) trazido(s) das AGCs anteriores.`
                        : (skipped ? "Nenhum novo: os credenciamentos validados já estão nesta AGC." : "Nenhum credenciamento validado nas AGCs anteriores deste caso.");
                    this.$dialog.notify.info(message, { position: "top-right", timeout: 4000 });
                    await this.loadAccreditations();
                    await this.loadPresenceStats();
                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
                } finally {
                    this.dataAccreditations.carrying = false;
                }
            },

            openSingleDeletion(item) {
                this.singleDeletion.item = item;
                this.singleDeletion.show = true;
            },

            async openAccreditationDeletion() {
                const ids = this.dataAccreditations.selected.map((item) => item.id);
                if (!ids.length) return;
                this.accreditationDeletion.loading = true;
                this.accreditationDeletion.reason = "";
                this.accreditationDeletion.preview = null;
                this.accreditationDeletion.show = true;
                try {
                    const result = await axios.post('/api/admin/accreditations/deletion-preview', { ids });
                    this.accreditationDeletion.preview = result.data.content;
                } catch (error) {
                    this.closeAccreditationDeletion(true);
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
                } finally {
                    this.accreditationDeletion.loading = false;
                }
            },

            closeAccreditationDeletion(force = false) {
                if (this.accreditationDeletion.loading && !force) return;
                this.accreditationDeletion.show = false;
                this.accreditationDeletion.preview = null;
                this.accreditationDeletion.reason = "";
            },

            async confirmAccreditationDeletion() {
                if (!this.accreditationDeletion.preview || !this.accreditationDeletion.preview.can_delete) return;
                this.accreditationDeletion.loading = true;
                try {
                    const result = await axios.post('/api/admin/accreditations/delete-test-records', {
                        ids: this.accreditationDeletion.preview.records.map((item) => item.id),
                        reason: this.accreditationDeletion.reason,
                    });
                    this.$dialog.notify.info(
                        `${result.data.content.removed} credenciamento(s) removido(s), sem envio de e-mail.`,
                        { position: 'top-right', timeout: 3000 }
                    );
                    this.dataAccreditations.selected = [];
                    this.closeAccreditationDeletion(true);
                    await this.loadAccreditations();
                    await this.loadPresenceStats();
                } catch (error) {
                    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 6000 });
                } finally {
                    this.accreditationDeletion.loading = false;
                }
            },

	        async loadVotings() {
	            if (!this.dataset.data.id) return;

	            this.voting.loading = true;

	            try {
	                const result = await axios.get(`/api/admin/general-meeting-votings/action/${this.dataset.data.id}`);
	                this.voting.items = result.data.content || [];
	                this.dataset.data.votingExist = this.voting.items.length > 0;
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.voting.loading = false;
	            }
	        },

	        openVotingForm(isNew = true, item = null) {
	            this.voting.form.isNew = isNew;
	                this.voting.form.data = {
	                id: item ? item.id : null,
	                name: item ? item.name : "",
	                description: item ? item.description : "",
	                type: item ? item.type : null,
	                status: item ? item.status : 1,
	                scenario_id: item ? item.scenario_id : null,
	                scenario_ids: item ? [...(item.scenario_ids || (item.scenario_id ? [item.scenario_id] : []))] : [],
	            };
	            this.voting.form.show = true;

	            this.$nextTick(() => {
	                if (this.$refs.votingForm) this.$refs.votingForm.resetValidation();
	            });
	        },

	        closeVotingForm() {
	            if (this.voting.form.loading) return;

	            this.voting.form.show = false;
	        },

            goToScenarios() {
                this.$router.push({
                    path: `/agcs/${this.dataset.data.id}/cenarios`,
                    query: this.voting.form.data.id
                        ? { voting_id: this.voting.form.data.id }
                        : {},
                });
            },

	        buildVotingPayload() {
	            const formData = new FormData();

	            if (this.voting.form.isNew) {
	                formData.append('general_meeting_id', this.dataset.data.id);
	            } else {
	                formData.append('id', this.voting.form.data.id);
	            }

	            if (this.voting.form.data.type)
	                formData.append('type', this.voting.form.data.type);
	            if (this.voting.form.data.status)
	                formData.append('status', this.voting.form.data.status);
	            if (this.voting.form.data.name)
	                formData.append('name', this.voting.form.data.name);
	            if (this.voting.form.data.description)
	                formData.append('description', this.voting.form.data.description);
	            if (this.voting.form.data.scenario_id)
	                formData.append('scenario_id', this.voting.form.data.scenario_id);
	            // Cenarios marcados (checkbox); a API inclui o base automaticamente.
	            formData.append('scenario_ids', JSON.stringify(this.voting.form.data.scenario_ids || []));

	            return formData;
	        },

	        async loadScenarios() {
	            if (!this.dataset.data.id) return;

	            try {
	                const result = await axios.get(`/api/admin/general-meeting-votings/scenarios/${this.dataset.data.id}`);
	                this.scenario.items = result.data.content || [];
	                this.scenario.options = [
	                    { id: null, name: "Sem cenário" },
	                    ...this.scenario.items,
	                ];
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            }
	        },

	        getScenarioBlockedCount(item) {
	            if (!item) return 0;
	            if (item.blocked_count !== undefined && item.blocked_count !== null) return item.blocked_count;
	            if (Array.isArray(item.participants)) return item.participants.filter((participant) => Number(participant.blocked) === 1).length;
	            return [
	                ...(item.blocked_user_ids || []),
	                ...(item.blocked_accreditation_general_meeting_ids || []),
	                ...(item.blocked_user_creditor_ids || []),
	            ].length;
	        },

	        async openScenarioDialog(item = null) {
	            this.scenario.dialog = true;

	            await this.loadScenarios();

	            if (item) {
	                this.selectScenario(item);
	                return;
	            }

	            if (this.scenario.form.data.id) {
	                await this.loadScenarioCreditors(this.scenario.form.data.id);
	                return;
	            }

	            this.newScenario();
	        },

	        closeScenarioDialog() {
	            if (this.scenario.loading || this.scenario.form.loading) return;
	            this.scenario.dialog = false;
	        },

	        async newScenario() {
	            this.scenario.form.data = {
	                id: null,
	                name: "",
	                blocked_user_creditor_ids: [],
	                blocked_accreditation_general_meeting_ids: [],
	                blocked_user_ids: [],
	            };
	            await this.loadScenarioCreditors(null);
	        },

	        async selectScenario(item) {
	            this.scenario.form.data = {
	                id: item.id,
	                name: item.name,
	                blocked_user_creditor_ids: [...(item.blocked_user_creditor_ids || [])],
	                blocked_accreditation_general_meeting_ids: [...(item.blocked_accreditation_general_meeting_ids || [])],
	                blocked_user_ids: [...(item.blocked_user_ids || [])],
	            };
	            await this.loadScenarioCreditors(item.id);
	        },

	        async selectScenarioById(id) {
	            if (!id) {
	                await this.newScenario();
	                return;
	            }

	            const item = this.scenario.items.find((scenario) => Number(scenario.id) === Number(id));

	            if (item) {
	                await this.selectScenario(item);
	            }
	        },

	        async loadScenarioCreditors(scenarioId = null) {
	            this.scenario.loading = true;

	            try {
	                const result = await axios.get(`/api/admin/general-meeting-votings/scenario-creditors/${this.dataset.data.id}`, {
	                    params: { scenario_id: scenarioId }
	                });

	                this.scenario.creditors = (result.data.content || []).map((item) => ({
	                    ...item,
	                    scenario_class: item.scenario_class || item.type || null,
	                    amount: item.amount || 0,
	                    currency: item.currency || 1,
	                    registration: item.registration ? this.formatRegistrationValue(item.registration) : '',
	                }));

	                if (scenarioId) {
	                    this.scenario.form.data.blocked_user_creditor_ids = this.scenario.creditors
	                        .filter((item) => item.blocked)
	                        .filter((item) => item.id)
	                        .map((item) => item.id);
	                    this.scenario.form.data.blocked_accreditation_general_meeting_ids = this.scenario.creditors
	                        .filter((item) => item.blocked)
	                        .map((item) => item.accreditation_general_meeting_id);
	                    this.scenario.form.data.blocked_user_ids = this.scenario.creditors
	                        .filter((item) => item.blocked)
	                        .map((item) => item.user_id);
	                }
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.scenario.loading = false;
	            }
	        },

	        isScenarioCreditorBlocked(item) {
	            return !!item && !!item.blocked;
	        },

	        toggleScenarioBlockedCreditor(item) {
	            if (item) item.blocked = !item.blocked;
	        },

	        addManualScenarioParticipant() {
                this.scenario.filter = "";
	            this.scenario.creditors = [
	                {
	                    local_id: `manual-${Date.now()}`,
	                    name: '',
	                    email: '',
	                    registration: '',
	                    scenario_class: null,
	                    amount: 0,
	                    currency: 1,
	                    has_presence: true,
	                    blocked: false,
	                    origin: 2,
	                },
	                ...this.scenario.creditors,
	            ];
	        },

	        removeManualScenarioParticipant(item) {
	            this.scenario.creditors = this.scenario.creditors.filter((participant) => participant !== item);
	        },

	        async saveScenario() {
	            if (!this.scenario.form.data.name) {
	                this.$dialog.notify.error("Informe o nome do cenário.", { position: 'top-right', timeout: 2000 });
	                return;
	            }

	            const invalidManual = this.scenario.creditors.find((item) => {
	                if (Number(item.origin) !== 2) return false;

	                const registration = this.onlyDigits(item.registration);
	                return !item.name || !registration || !item.scenario_class;
	            });

	            if (invalidManual) {
	                this.$dialog.notify.error("Informe nome, CPF/CNPJ e classe dos credores manuais.", { position: 'top-right', timeout: 3000 });
	                return;
	            }

	            this.scenario.form.loading = true;

	            try {
	                const result = await axios.post('/api/admin/general-meeting-votings/scenarios', {
	                    id: this.scenario.form.data.id,
	                    name: this.scenario.form.data.name,
	                    general_meeting_id: this.dataset.data.id,
		                    participants: this.scenario.creditors.map((item) => ({
		                        accreditation_general_meeting_id: item.accreditation_general_meeting_id || null,
		                        user_creditor_id: item.user_creditor_id || item.id || null,
		                        user_id: item.user_id || null,
		                        name: item.name,
		                        email: item.email || null,
		                        registration: this.onlyDigits(item.registration),
		                        creditor_class: item.scenario_class || item.type || null,
		                        amount: item.amount || 0,
		                        currency: item.currency || 1,
		                        blocked: !!item.blocked,
		                        origin: item.origin || 1,
		                    })),
	                });

	                this.$dialog.notify.info("Cenário salvo com sucesso!", { position: "top-right", timeout: 2000 });
	                await this.loadScenarios();

	                const savedScenarioId = result.data.content ? result.data.content.id : null;
	                const savedScenario = this.scenario.items.find((item) => Number(item.id) === Number(savedScenarioId));
	                if (savedScenario) await this.selectScenario(savedScenario);
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.scenario.form.loading = false;
	            }
	        },

	        async deleteScenario(item) {
	            const proceedAction = await this.$dialog.confirm({
	                text: 'Deseja excluir este cenário? As votações vinculadas ficarão sem cenário.',
	                title: 'Excluir cenário',
	                actions: {
	                    false: 'Cancelar',
	                    true: 'Excluir'
	                }
	            });

	            if (!proceedAction) return;

	            this.scenario.loading = true;

	            try {
	                await axios.delete(`/api/admin/general-meeting-votings/scenarios/${item.id}`);
	                this.$dialog.notify.info("Cenário excluído com sucesso!", { position: "top-right", timeout: 2000 });
	                await this.loadScenarios();
	                await this.loadVotings();
	                await this.newScenario();
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.scenario.loading = false;
	            }
	        },

	        async saveVotingForm() {
	            if (!this.$refs.votingForm.validate()) return;

	            const proceedAction = await this.$dialog.confirm({
	                text: this.voting.form.isNew ? 'Deseja incluir a votação?' : 'Deseja atualizar dados da votação?',
	                title: this.voting.form.isNew ? 'Incluir votação' : 'Atualizar votação',
	                actions: {
	                    false: 'Cancelar',
	                    true: this.voting.form.isNew ? 'Salvar' : 'Atualizar'
	                }
	            });

	            if (!proceedAction) return;

	            this.voting.form.loading = true;

	            try {
	                const payload = this.buildVotingPayload();

	                if (this.voting.form.isNew) {
	                    await axios.post('/api/admin/general-meeting-votings', payload);
	                    this.$dialog.notify.info("Votação criada com sucesso!", { position: "top-right", timeout: 2000 });
	                } else {
	                    await axios.patch(`/api/admin/general-meeting-votings/${this.voting.form.data.id}`, payload);
	                    this.$dialog.notify.info("Votação atualizada com sucesso!", { position: "top-right", timeout: 2000 });
	                }

	                this.voting.form.show = false;
	                await this.loadVotings();
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.voting.form.loading = false;
	            }
	        },

	        getVotingStatusName(value) {
	            const status = this.voting.statuses.find((item) => item.id === value);
	            return status ? status.name : 'N/A';
	        },

	        getVotingTypeName(value) {
	            const type = this.voting.types.find((item) => item.id === value);
	            return type ? type.name : 'N/A';
	        },

	        getVotingStatusColor(status) {
	            switch (status) {
	                case 1:
	                    return 'grey';
	                case 2:
	                    return 'accent';
	                case 3:
	                    return 'warning';
	                case 4:
	                    return 'error';
	                case 5:
	                    return 'success';
	                default:
	                    return 'grey';
	            }
	        },

	        goToVoting(item) {
	            this.$router.push(`/agcs/votacao/${item.id}`);
	        },

	        async deleteVoting(item) {
	            if (!item || !item.id) return;

	            if (item.status !== 1 && item.status !== 4 && item.status !== 5) {
	                this.$dialog.notify.error("Votação não pode ser excluída! Verifique status da votação!", { position: "top-right", timeout: 5000 });
	                return;
	            }

	            const proceedAction = await this.$dialog.confirm({
	                text: 'Tem certeza que deseja continuar?',
	                title: 'Excluir votação',
	                actions: {
	                    false: 'Cancelar',
	                    true: 'Excluir'
	                }
	            });

	            if (!proceedAction) return;

	            this.voting.loading = true;

	            try {
	                await axios.delete(`/api/admin/general-meeting-votings/${item.id}`);
	                this.$dialog.notify.info("Votação excluída com sucesso!", { position: "top-right", timeout: 2000 });
	                await this.loadVotings();
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.voting.loading = false;
	            }
	        },

	        async setVotingStatus(item, status) {
	            if (!item || !item.id) return;
	            if (item.status === status) return;

	            if ((item.status === 4 || item.status === 5) && (status === 2 || status === 3)) {
	                this.$dialog.notify.error("Votação não pode ser iniciada! Verifique status da votação!", { position: "top-right", timeout: 5000 });
	                return;
	            }

	            if (status === 2 && this.dataset.data.status !== 5) {
	                this.$dialog.notify.error("Votação não pode ser iniciada! Verifique status da Assembleia!", { position: "top-right", timeout: 5000 });
	                return;
	            }

	            this.voting.loading = true;

	            try {
	                await axios.patch(`/api/admin/general-meeting-votings/set-status/${item.id}`, { status });
	                this.$dialog.notify.info("Status da votação atualizado com sucesso!", { position: "top-right", timeout: 2000 });
	                await this.loadVotings();
	            } catch (error) {
	                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
	            } finally {
	                this.voting.loading = false;
	            }
	        },

	        pageChanged(page) {
            this.dataAccreditations.options.page = page;
            this.loadAccreditations();
        },

        pageSizeChanged(size) {
            this.dataAccreditations.options.itemsPerPage = size;
            this.loadAccreditations();
        },

        buildPayload() {
            const payload = {
                name: this.dataset.data.name,
                convocation_type: this.dataset.data.convocation_type || 1,
                date: this.$moment(this.dataset.data.date).format("YYYY-MM-DD HH:mm:ss"),
                client_id: this.dataset.data.client_id,
                description: this.dataset.data.description,
                accreditation_enabled: !!this.dataset.data.accreditation_enabled,
                accreditation_starts_at: this.dataset.data.accreditation_starts_at
                    ? this.$moment(this.dataset.data.accreditation_starts_at).format("YYYY-MM-DD HH:mm:ss")
                    : null,
                accreditation_ends_at: this.dataset.data.accreditation_ends_at
                    ? this.$moment(this.dataset.data.accreditation_ends_at).format("YYYY-MM-DD HH:mm:ss")
                    : null,
            };

            if (!this.exchangeRatesLocked) {
                payload.exchange_rate_usd = this.dataset.data.exchange_rate_usd;
                payload.exchange_rate_eur = this.dataset.data.exchange_rate_eur;
                payload.exchange_rate_date = this.dataset.data.exchange_rate_date
                    ? this.$moment(this.dataset.data.exchange_rate_date).format("YYYY-MM-DD HH:mm:ss")
                    : null;
            }

            return payload;
        },

        async loadCaseSessions() {
            const clientId = this.dataset.data && this.dataset.data.client_id;
            if (!clientId) { this.caseSessions = []; return; }
            try {
                const result = await axios.get("/api/admin/general-meetings/sessions", { params: { client_id: clientId } });
                this.caseSessions = (result.data.content.groups || []).flatMap((group) => group.sessions || []);
            } catch (error) {
                this.caseSessions = [];
            }
        },

        openConvert() {
            const last = this.installedSessions[this.installedSessions.length - 1];
            this.convert = { open: true, source: last ? last.id : null, reason: "", loading: false };
        },

        async confirmConvert() {
            this.convert.loading = true;
            try {
                const result = await axios.post(`/api/admin/general-meetings/${this.dataset.data.id}/convert-to-continuation`, {
                    source_general_meeting_id: this.convert.source,
                    reason: this.convert.reason,
                });
                const content = result.data.content;
                this.$dialog.notify.info(`AGC transformada no Prosseguimento ${content.continuation_number - 1}. ${content.copied_accreditations} credenciamento(s) trazido(s) da sessão anterior.`, { position: "top-right", timeout: 5000 });
                this.convert.open = false;
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 6000 });
            } finally {
                this.convert.loading = false;
            }
        },

        async add() {
            if (!this.$refs.form.validate()) return;
            if (this.continuationWarning) {
                const confirmed = await this.$dialog.confirm({
                    title: "Criar como sessão nova?",
                    text: "Prosseguimento não se cria por aqui: abra a sessão que instalou e use Suspender Assembleia. Criada por aqui, esta AGC conta como sessão nova, sem herdar a instalação. Criar mesmo assim?",
                    actions: { false: "Cancelar", true: "Criar sessão nova" },
                });
                if (!confirmed) return;
            }

            if(!this.dataset.data.date || !this.$moment(this.dataset.data.date).isValid()) {
                this.$dialog.notify.error("Selecione uma data válida!", { position: 'top-right', timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a Assembleia?',
                title: 'Incluir Assembleia',
                actions: { false: 'Cancelar', true: 'Salvar' }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            try {
                await axios.post('/api/admin/general-meetings', this.buildPayload());
                this.$dialog.notify.info("Assembleia salva com sucesso", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;    

            if(!this.dataset.data.date || !this.$moment(this.dataset.data.date).isValid()) {
                this.$dialog.notify.error("Selecione uma data válida!", { position: 'top-right', timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a Assembleia?',
                title: 'Atualizar Assembleia',
                actions: { false: 'Cancelar', true: 'Atualizar' }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            try {
                await axios.patch(`/api/admin/general-meetings/${this.$route.params.id}`, this.buildPayload());
                this.$dialog.notify.info("Assembleia salva com sucesso", { position: "top-right", timeout: 2000 });
                this.load(); 
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        async actionGeneralMeeting(id, type, status) {
            if ([3, 7].includes(Number(type))) {
                this.openInterruptionDialog(id, type, status);
                return;
            }

            let dialogMessage = "Deseja atualizar a Assembleia?";
            switch (type) {
                case 3: dialogMessage = "Deseja suspender a Assembleia?"; break;
                case 7: dialogMessage = "Deseja interromper a Assembleia?"; break;
                case 1: 
                case 6: dialogMessage = "Deseja abrir a Assembleia?"; break;
                case 8: dialogMessage = "Deseja iniciar a Assembleia?"; break;
                case 9: dialogMessage = "Deseja finalizar a Assembleia?"; break;
                case 10: dialogMessage = "Deseja reabrir a Assembleia?"; break;
                case 11: dialogMessage = "Deseja prosseguir a Assembleia?"; break;
            }

            const proceedAction = await this.$dialog.confirm({
                text: dialogMessage,
                title: 'Atenção!',
                actions: { false: 'Cancelar', true: 'Confirmar' }
            });

            if (!proceedAction) return;

            try {
                await axios.patch(`/api/admin/general-meetings/action/${id}`, { status, type });
                this.$dialog.notify.info("Assembleia atualizada com sucesso", { position: "top-right", timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },

        openInterruptionDialog(id, type, status) {
            this.interruptionDialog.show = true;
            this.interruptionDialog.loading = false;
            this.interruptionDialog.id = id;
            this.interruptionDialog.type = type;
            this.interruptionDialog.status = status;
            this.interruptionDialog.nextConvocationDate = this.dataset.data.next_convocation_date
                ? this.$moment(this.dataset.data.next_convocation_date).format("YYYY-MM-DDTHH:mm")
                : "";
            this.interruptionDialog.reason = "";
            this.interruptionDialog.votingReuseMode = "structure";
        },

        closeInterruptionDialog(force = false) {
            if (this.interruptionDialog.loading && !force) return;

            this.interruptionDialog.show = false;
            this.interruptionDialog.id = null;
            this.interruptionDialog.nextConvocationDate = "";
            this.interruptionDialog.reason = "";
            this.interruptionDialog.votingReuseMode = "structure";
        },

        async confirmInterruption() {
            const nextConvocationDate = this.interruptionDialog.nextConvocationDate;

            if (nextConvocationDate && (!this.$moment(nextConvocationDate).isValid() || this.$moment().diff(nextConvocationDate, 'seconds') > 0)) {
                this.$dialog.notify.error("Informe uma próxima convocação válida.", { position: 'top-right', timeout: 2000 });
                return;
            }
            if (this.interruptionDialog.type === 3 && !nextConvocationDate) {
                this.$dialog.notify.error("Informe a data e hora da continuação.", { position: 'top-right', timeout: 2000 });
                return;
            }
            if (this.interruptionDialog.type === 3 && !this.interruptionDialog.reason.trim()) {
                this.$dialog.notify.error("Informe o motivo da suspensão.", { position: 'top-right', timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: this.interruptionDialog.type === 3 ? 'Deseja suspender a Assembleia?' : 'Deseja interromper a Assembleia?',
                title: 'Atenção!',
                actions: { false: 'Cancelar', true: 'Confirmar' }
            });

            if (!proceedAction) return;

            this.interruptionDialog.loading = true;

            try {
                const payload = {
                    status: this.interruptionDialog.status,
                    type: this.interruptionDialog.type,
                    next_convocation_date: nextConvocationDate
                        ? this.$moment(nextConvocationDate).format("YYYY-MM-DD HH:mm:ss")
                        : null,
                    reason: this.interruptionDialog.reason,
                    voting_reuse_mode: this.interruptionDialog.votingReuseMode,
                };

                const result = await axios.patch(`/api/admin/general-meetings/action/${this.interruptionDialog.id}`, payload);
                const continuationId = result.data && result.data.content && result.data.content.continuation_general_meeting_id;
                this.$dialog.notify.info(
                    continuationId ? "Assembleia suspensa e continuação criada com sucesso" : "Assembleia atualizada com sucesso",
                    { position: "top-right", timeout: 2500 }
                );
                this.closeInterruptionDialog(true);
                if (continuationId) {
                    this.$router.push(`/agcs/${continuationId}`);
                } else {
                    this.load();
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.interruptionDialog.loading = false;
            }
        },

        goToPresence() {
            if (this.dataset.data.id) {
                this.$router.push({ path: `/agcs/presenca/${this.dataset.data.id}` });
            }
        },

        viewItem(item) {
            if (this.$refs.accreditationDetailsModalRef) {
                this.$refs.accreditationDetailsModalRef.setData(item);
                this.$refs.accreditationDetailsModalRef.open().then(() => {
                    this.loadAccreditations();
                });
            }
        },

        openDialogInsertNotice(item) {
            if (this.$refs.fileUploadDialogRef) {
                this.$refs.fileUploadDialogRef.setData(item);
                this.$refs.fileUploadDialogRef.open().then(() => {
                    this.load();
                });
            }
        },

        viewNoticeFile(notice) {
            if (notice.fileUrl) {
                window.open(notice.fileUrl, '_blank');
            }
        },

        async deleteNotice(notice) {
            const proceedAction = await this.$dialog.confirm({
                text: `Deseja excluir o edital "${notice.name}"?`,
                title: 'Excluir Edital',
                actions: { false: 'Cancelar', true: 'Excluir' }
            });

            if (!proceedAction) return;

            try {
                await axios.delete(`/api/admin/general-meetings/notices/${notice.id}`);
                this.$dialog.notify.info("Edital excluído com sucesso", { position: "top-right", timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },

        openAddInformationModal(item) {
            if (this.$refs.generalMeetingCommentsModalRef) {
                this.$refs.generalMeetingCommentsModalRef.setData(item);
                this.$refs.generalMeetingCommentsModalRef.open().then(() => {
                    this.load();
                });
            }
        },

        getColorByStatus(status) {
            switch (status) {
                case 0: return 'warning'
                case 1: return 'accent'
                case 2: return 'error'
                case 3: return 'purple'
                default: return 'grey'
            }
        },

        getParticipationTypeLabel(participationType) {
            return Number(participationType || 1) === 2 ? 'Ouvinte' : 'Credor';
        },

        resolveColorDeadlineAccreditation(percentage) {
            if (percentage > 0 && percentage < 50) return '#FFCC80';
            if (percentage >= 50 && percentage < 80) return '#F9AA33';
            return '#FF5252';
        },

        getCreditorClassLabel(classId) {
            const found = (this.dataset.creditorTypes || []).find((item) => Number(item.id) === Number(classId));
            return found ? found.name : (classId ? `Classe ${classId}` : 'N/A');
        },

        formatCreditAmount(amount, currency) {
            const value = Number(amount);
            if (!Number.isFinite(value)) return 'N/A';
            const codes = { 1: 'BRL', 2: 'USD', 3: 'EUR' };
            const code = codes[Number(currency)] || 'BRL';
            return value.toLocaleString('pt-BR', { style: 'currency', currency: code });
        },

        // Busca enquanto digita, com pausa curta para nao chamar a API a cada tecla.
        onAccreditationSearch: _.debounce(function () {
            this.dataAccreditations.options.page = 1;
            this.dataAccreditations.selected = [];
            this.loadAccreditations();
        }, 400),

        onAccreditationParticipationChange() {
            this.dataAccreditations.options.page = 1;
            this.dataAccreditations.selected = [];
            this.loadAccreditations();
        },

        async generateCSV() {
            const data = this.dataAccreditations.data;
            if (!data || data.length === 0) {
                this.$dialog.notify.warning("Sem dados para exportar!", { position: "top-right", timeout: 2000 });
                return;
            }

            const newData = data.map(objeto => ({
                "NOME CREDOR": objeto.accreditation.user.name,
                "EMAIL CREDOR": objeto.accreditation.user.email,
                "NOME PROCURADOR": objeto.procurator_name || "N/A",
                "EMAIL PROCURADOR": objeto.procurator_email || "N/A",
                "PARTICIPACAO": this.getParticipationTypeLabel(objeto.participation_type),
                "CLASSE": (objeto.qgc_credits || []).map((credit) => this.getCreditorClassLabel(credit.class)).join(' | ') || "N/A",
                "CREDITO": (objeto.qgc_credits || []).map((credit) => this.formatCreditAmount(credit.amount, credit.currency)).join(' | ') || "N/A",
                "SOLICITADO EM": this.$options.filters.defaultDate(objeto.created_at, "DD/MM/YYYY HH:mm [BRT]"),
                "STATUS": objeto.status === 0 ? "Pendente" : (objeto.status === 1 ? "Aprovado" : (objeto.status === 3 ? "Regularização solicitada" : "Rejeitado")),
                "JUSTIFICATIVA (OUVINTE)": objeto.interest_justification || "",
            }));

            const listeners = Number(this.dataAccreditations.participation) === 2;
            await downloadXlsx(newData, listeners ? 'ouvintes' : 'credenciamentos', { sheetName: listeners ? 'Ouvintes' : 'Credenciamentos' });
        }
    },
};
</script>

<style lang="scss">
.redo-installation__compare { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border: 1px solid #E5E7EB; border-radius: 6px; }
.redo-installation__compare > div { display: flex; flex-direction: column; flex: 1; font-size: 13px; }
/* Credenciamento transportado de uma AGC anterior do caso */
.carried-from { margin-top: 4px; font-size: 11.5px; color: #6B7280; white-space: nowrap; }

@import "../../assets/scss/ui/tokens";

// Os dialogs entre as secoes quebram o espacamento ".ui-card + .ui-card"
.agc-details-sections > .ui-card:not(:first-child) {
    margin-top: 16px;
}
/* Subtitulo de cada grafico na projecao. */
.agc-projection-chart-title {
    font-size: 15px;
    font-weight: 700;
    color: #374151;
    text-align: center;
    margin-bottom: 8px;
}

.agc-projection-summary {
    font-size: 20px;
    font-weight: 700;
    color: $ui-fg;
}
.agc-projection-status {
    margin-left: 16px;
}
.agc-projection-status--ok {
    color: nth(map-get($ui-tones, success), 3);
}
.agc-projection-status--fail {
    color: nth(map-get($ui-tones, danger), 3);
}
.install-preview {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
}
.install-preview__card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid $ui-border;
    border-radius: $ui-radius-sm;
}
.install-preview__card > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.install-preview__card strong {
    font-size: 15px;
    color: $ui-fg;
}
.install-preview__card--ok {
    background: nth(map-get($ui-tones, success), 1);
}
.install-preview__card--fail {
    background: nth(map-get($ui-tones, danger), 1);
}
.title-page {
    color: var(--v-primary-base);
    font-size: 40px;
    font-weight: 700;
}
.icon-container {
    display: flex;
    align-items: center;
}
.scenario-dialog-card {
    max-height: calc(100vh - 48px);
    display: flex;
    flex-direction: column;
}
.scenario-dialog-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}
.scenario-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 18px;
}
.scenario-selector-field {
    flex: 0 1 340px;
    min-width: 260px;
}
.scenario-name-field {
    flex: 1;
    min-width: 0;
}
.scenario-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-shrink: 0;
}
.scenario-management-layout {
    min-height: 0;
}
.scenario-workspace {
    min-width: 0;
}
.scenario-creditors-table {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
}
.scenario-creditors-table .v-data-table-header th {
    background: #fff !important;
    z-index: 2;
}
.scenario-creditors-table .v-data-table__wrapper {
    overflow-x: auto;
}
.scenario-section-label {
    color: #6b7280;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0;
}
@media (max-width: 960px) {
    .scenario-dialog {
        margin: 12px;
    }
    .scenario-dialog-card {
        max-height: calc(100vh - 24px);
    }
    .scenario-toolbar {
        align-items: stretch;
        flex-direction: column;
    }
    .scenario-actions {
        justify-content: flex-start;
    }
    .scenario-management-layout {
        grid-template-columns: 1fr;
    }
    .scenario-selector-field {
        flex-basis: auto;
        min-width: 0;
    }
}
</style>
